import { urlAdmin } from '../library/scripts/Setup.svelte'
import { storeImageModal, storeData } from '../library/scripts/Store.svelte'
import { admin } from '../library/scripts/PhpHandler.svelte'

const un_subscribe = (unsubscribe) => {
	unsubscribe.forEach((value) => {
		value
	})
}

export const send_mail = async (cmd, data) => {
	const response = await php_handler(cmd, data)

	if (response) return response
}

export const get_db_entries = async (dbtable) => {
	const dbEntries = await admin({ cmd: 'get_db_entries', table: dbtable })
	if (dbEntries) {
		return dbEntries
	}
}

//get the logo values
export let get_logo_values = (config) => {
	let bgColor, height, top, left
	bgColor = config.logo.backgroundColor
	height = config.logo.imageHeight
	top = config.logo.top
	left = config.logo.left

	//create the opac value
	const logoOpacColor = bgColor.split(',')
	const logoOpac = logoOpacColor[3].slice(0, logoOpacColor[3].length - 1)

	return [bgColor, logoOpac, height, top, left]
}

export const get_element_tags = (elementID) => {
	const elementTags = elementID.split('_')
	const blockID = elementTags[0]

	//single image block
	if (elementTags[1] === 'singleImageBlock') {
		return [blockID, 'singleImageBlock', '']
	}
	let columnID = elementTags[2]
	let cssTag = elementTags[1]

	if (columnID && columnID !== '') columnID = parseInt(columnID) + 1
	else columnID = ''

	if (!cssTag || cssTag === 'column') cssTag = ''
	else cssTag = elementTags[1].charAt(0).toUpperCase() + elementTags[1].slice(1)

	//changed values for block & column background
	if ((columnID && !cssTag) || (!columnID && !cssTag)) cssTag = ''

	//css tag for column title & text

	if (columnID && cssTag.length == 0) {
		cssTag = `Column ${columnID}`
		return [blockID, columnID, cssTag]
	}
	if (columnID && cssTag.length > 1) {
		cssTag = `Column ${columnID} ${cssTag}`
		return [blockID, columnID, cssTag]
	}

	return [blockID, columnID, cssTag]
}

export const get_blocks = (configFile) => {
	//array that holds the sorted entries
	let sortArray = new Array(configFile.blocks.length)

	configFile.blocks.forEach((block) => {
		sortArray[block.layoutOrder] = block
	})

	configFile.blocks = sortArray
	return configFile.blocks
}

export const get_links = async (path) => {
	const response = await php_handler('getconfigfile', path)
	const widgets = response.widgets.split(',')
	const links = []

	widgets.forEach((link) => {
		if (link === 'admin' || link === 'gallery') links.push(link)
	})

	return links
}

export const php_handler = async (cmd, data) => {
	try {
		const response = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ cmd: cmd, data: data }),
		})

		const dataResponse = await response.json()
		if (cmd === 'getconfigfile') {
			let configFile = get_blocks(dataResponse)
			return configFile
		}

		return dataResponse
	} catch (e) {
		return { sent: false, code: 'ERROR: es konnte keine Verbindung hergestellt werden', error: e }
	}
}

export const get_initial_site_values = (config) => {
	const configFile = config
	const siteSetting = get_site_settings(configFile)
	return siteSetting
}

export const get_initial_navbar_values = (config) => {
	const navbarSetting = get_navbar_settings(config)
	return navbarSetting
}

export const get_initial_values = (elementID, blocks, tags) => {
	const blockID = tags[0]
	const columnID = tags[1]
	const elementTag = tags[2]
	const elementTags = elementTag.split(' ')
	let elementSlider = false
	let elementGallery = false
	let elementBlock = false
	let elementBlockTitle = false
	let elementColumn = false
	let elementColumnTitle = false
	let elementColumnText = false
	let elementColumnImage = false
	let elementSingleImageBlock = false
	let elementContactBlock = false
	let elementMenu = false
	let elementRooms = false
	let elementBooking = false

	//check which element is selected
	if (blockID === 'drinks' || blockID === 'foods') {
		elementMenu = true
	}

	if (blockID === 'rooms') {
		elementRooms = true
	}
	if (blockID === 'cover-slider') {
		elementSlider = true
	}

	if (blockID === 'Contact') {
		elementContactBlock = true
	}

	if (blockID === 'booking') {
		elementBooking = true
	}

	if (blockID === 'gallery') {
		if (elementTags[0] === 'BlockTitle') elementBlockTitle = true
		else elementGallery = true
	}

	//block
	if (elementTags.length === 1 && columnID === '' && blockID !== 'Contact' && blockID !== 'booking') {
		if (elementTags[0] === '') elementBlock = true
		if (elementTags[0] === 'BlockTitle') elementBlockTitle = true
	}

	//single image block
	if (elementTags.length === 1 && columnID === 'singleImageBlock') {
		elementSingleImageBlock = true
	}

	if (elementTags.length === 2) {
		elementColumn = true
	}

	if (elementTags.length === 3) {
		if (elementTags[2] === 'Title') elementColumnTitle = true
		if (elementTags[2] === 'Text') elementColumnText = true
		if (elementTags[2] === 'Image') elementColumnImage = true
	}

	if (elementMenu) {
		let drinksSettings = get_menu_settings(blocks, blockID)
		return drinksSettings
	}

	if (elementRooms) {
		let menuSettings = get_rooms_settings(blocks, blockID)
		return menuSettings
	}

	if (elementSlider) {
		let blockSettings = get_block_settings(blocks, blockID)
		let sliderSettings = get_slider_settings(blocks, blockID)
		blockSettings.push(sliderSettings)
		return blockSettings
	}

	if (elementGallery) {
		let gallerySettings = get_columnImage_settings(blocks, blockID, 2)
		let blockSettings = get_block_settings(blocks, blockID)
		let galleryBlockSettings = get_gallery_settings(blocks, blockID)
		gallerySettings.push(blockSettings, galleryBlockSettings)
		return gallerySettings
	}

	if (elementBlock) {
		const blockSettings = get_block_settings(blocks, blockID)
		return blockSettings
	}

	if (elementContactBlock) {
		const blockSettings = get_contact_settings(blocks, blockID)
		return blockSettings
	}

	if (elementBooking) {
		const bookingSettings = get_booking_settings(blocks, blockID)
		return bookingSettings
	}

	if (elementSingleImageBlock) {
		const blockSettings = get_single_image_block_settings(blocks, blockID)
		return blockSettings
	}

	if (elementBlockTitle) {
		const blockTitleSettings = get_blockTitle_settings(blocks, blockID, columnID, elementTag)
		return blockTitleSettings
	}
	if (elementColumn) {
		const columnSettings = get_column_settings(blocks, blockID, columnID)
		return columnSettings
	}
	if (elementColumnTitle) {
		const titleSettings = get_columnTitle_settings(blocks, blockID, columnID, elementTag)
		return titleSettings
	}
	if (elementColumnText) {
		const textSettings = get_columnText_settings(blocks, blockID, columnID)
		return textSettings
	}

	if (elementColumnImage) {
		const imageSettings = get_columnImage_settings(blocks, blockID, columnID)
		return imageSettings
	}
}

export async function create_block_template(template, block, blockArray) {
	let orig, change
	blockArray.forEach((item) => {
		if (item.blockName === template) orig = item
		if (item.blockName === block) change = item
	})

	change.blockTitleWidth = orig.blockTitleWidth
	change.blockTitleAlignHorizontal = orig.blockTitleAlignHorizontal
	change.blockTitleAlignVertical = orig.blockTitleAlignVertical
	change.blockTitleFontFamily = orig.blockTitleFontFamily
	change.blockTitleFontColor = orig.blockTitleFontColor
	change.blockTitleFontSize = orig.blockTitleFontSize
	change.blockTitleFontWeight = orig.blockTitleFontWeight
	change.blockTitleFontStyle = orig.blockTitleFontStyle
	change.blockTitleFontDeco = orig.blockTitleFontDeco
	change.blockTitleBackgroundColor = orig.blockTitleBackgroundColor
	change.blockTitleMarginTop = orig.blockTitleMarginTop
	change.blockTitleMarginBottom = orig.blockTitleMarginBottom
	change.blockTitlePadding = orig.blockTitlePadding
	change.blockIntro = orig.blockIntro
	change.blockIntroWidth = orig.blockIntroWidth
	change.blockIntroAlignHorizontal = orig.blockIntroAlignHorizontal
	change.blockIntroAlignVertical = orig.blockIntroAlignVertical
	change.blockIntroBackgroundColor = orig.blockIntroBackgroundColor
	change.blockIntroFontFamily = orig.blockIntroFontFamily
	change.blockIntroFontColor = orig.blockIntroFontColor
	change.blockIntroFontSize = orig.blockIntroFontSize
	change.blockIntroFontWeight = orig.blockIntroFontWeight
	change.blockIntroFontStyle = orig.blockIntroFontStyle
	change.blockIntroFontDeco = orig.blockIntroFontDeco
	change.blockIntroMargin = orig.blockIntroMargin
	change.blockIntroPadding = orig.blockIntroPadding
	change.blockIntroDeco = orig.blockIntroDeco
	change.backgroundColor = orig.backgroundColor
	change.backgroundImage = orig.backgroundImage
	change.backgroundSize = orig.backgroundSize
	change.backgroundRepeat = orig.backgroundRepeat
	change.borderTopRadius = orig.borderTopRadius
	change.borderBottomRadius = orig.borderBottomRadius
	change.borderLeftWidth = orig.borderLeftWidth
	change.borderLeftStyle = orig.borderLeftStyle
	change.borderLeftColor = orig.borderLeftColor
	change.borderTopWidth = orig.borderTopWidth
	change.borderTopStyle = orig.borderTopStyle
	change.borderTopColor = orig.borderTopColor
	change.borderRightWidth = orig.borderRightWidth
	change.borderRightStyle = orig.borderRightStyle
	change.borderRightColor = orig.borderRightColor
	change.borderBottomWidth = orig.borderBottomWidth
	change.borderBottomStyle = orig.borderBottomStyle
	change.borderBottomColor = orig.borderBottomColor
	change.marginTop = orig.marginTop
	change.marginBottom = orig.marginBottom
	change.padding = orig.padding
	change.blockBoxShadowX = orig.blockBoxShadowX
	change.blockBoxShadowY = orig.blockBoxShadowY
	change.blockBoxShadowBlur = orig.blockBoxShadowBlur
	change.blockBoxShadowColor = orig.blockBoxShadowColor

	//content
	change.content.forEach((item, index) => {
		if (orig.content[index]) {
			change.content[index].imageWidth = orig.content[index].imageWidth
			change.content[index].objectFit = orig.content[index].objectFit
			change.content[index].boxShadowX = orig.content[index].boxShadowX
			change.content[index].boxShadowY = orig.content[index].boxShadowY
			change.content[index].boxShadowBlur = orig.content[index].boxShadowBlur
			change.content[index].boxShadowColor = orig.content[index].boxShadowColor
			change.content[index].imageBorderTopRadius = orig.content[index].imageBorderTopRadius
			change.content[index].imageBorderBottomRadius = orig.content[index].imageBorderBottomRadius
			change.content[index].imageBorderLeftWidth = orig.content[index].imageBorderLeftWidth
			change.content[index].imageBorderLeftStyle = orig.content[index].imageBorderLeftStyle
			change.content[index].imageBorderLeftColor = orig.content[index].imageBorderLeftColor
			change.content[index].imageBorderTopWidth = orig.content[index].imageBorderTopWidth
			change.content[index].imageBorderTopStyle = orig.content[index].imageBorderTopStyle
			change.content[index].imageBorderTopColor = orig.content[index].imageBorderTopColor
			change.content[index].imageBorderRightWidth = orig.content[index].imageBorderRightWidth
			change.content[index].imageBorderRightStyle = orig.content[index].imageBorderRightStyle
			change.content[index].imageBorderRightColor = orig.content[index].imageBorderRightColor
			change.content[index].imageBorderBottomWidth = orig.content[index].imageBorderBottomWidth
			change.content[index].imageBorderBottomStyle = orig.content[index].imageBorderBottomStyle
			change.content[index].imageBorderBottomColor = orig.content[index].imageBorderBottomColor
			change.content[index].imageMarginTop = orig.content[index].imageMarginTop
			change.content[index].imageMarginBottom = orig.content[index].imageMarginBottom
			change.content[index].imagePadding = orig.content[index].imagePadding
			change.content[index].padding = orig.content[index].padding
			change.content[index].marginTop = orig.content[index].marginTop
			change.content[index].marginBottom = orig.content[index].marginBottom
			change.content[index].backgroundColor = orig.content[index].backgroundColor
			change.content[index].borderTopRadius = orig.content[index].borderTopRadius
			change.content[index].borderBottomRadius = orig.content[index].borderBottomRadius
			change.content[index].borderBackgroundImage = orig.content[index].borderBackgroundImage
			change.content[index].borderTopWidth = orig.content[index].borderTopWidth
			change.content[index].borderTopStyle = orig.content[index].borderTopStyle
			change.content[index].borderTopColor = orig.content[index].borderTopColor
			change.content[index].borderBottomWidth = orig.content[index].borderBottomWidth
			change.content[index].borderBottomStyle = orig.content[index].borderBottomStyle
			change.content[index].borderBottomColor = orig.content[index].borderBottomColor
			change.content[index].borderLeftWidth = orig.content[index].borderLeftWidth
			change.content[index].borderLeftStyle = orig.content[index].borderLeftStyle
			change.content[index].borderLeftColor = orig.content[index].borderLeftColor
			change.content[index].borderRightWidth = orig.content[index].borderRightWidth
			change.content[index].borderRightStyle = orig.content[index].borderRightStyle
			change.content[index].borderRightColor = orig.content[index].borderRightColor
			change.content[index].backgroundImage = orig.content[index].backgroundImage
			change.content[index].titleWidth = orig.content[index].titleWidth
			change.content[index].titleAlignHorizontal = orig.content[index].titleAlignHorizontal
			change.content[index].titleAlignVertical = orig.content[index].titleAlignVertical
			change.content[index].titleFontFamily = orig.content[index].titleFontFamily
			change.content[index].titleFontSize = orig.content[index].titleFontSize
			change.content[index].titleFontColor = orig.content[index].titleFontColor
			change.content[index].titleFontWeight = orig.content[index].titleFontWeight
			change.content[index].titleFontStyle = orig.content[index].titleFontStyle
			change.content[index].titleFontDeco = orig.content[index].titleFontDeco
			change.content[index].titleBackgroundColor = orig.content[index].titleBackgroundColor
			change.content[index].titleMarginTop = orig.content[index].titleMarginTop
			change.content[index].titleMarginBottom = orig.content[index].titleMarginBottom
			change.content[index].titlePadding = orig.content[index].titlePadding
			change.content[index].textWidth = orig.content[index].textWidth
			change.content[index].textAlignHorizontal = orig.content[index].textAlignHorizontal
			change.content[index].textAlignVertical = orig.content[index].textAlignVertical
			change.content[index].textFontFamily = orig.content[index].textFontFamily
			change.content[index].textFontSize = orig.content[index].textFontSize
			change.content[index].textFontColor = orig.content[index].textFontColor
			change.content[index].textFontWeight = orig.content[index].textFontWeight
			change.content[index].textFontStyle = orig.content[index].textFontStyle
			change.content[index].textFontDeco = orig.content[index].textFontDeco
			change.content[index].textBackgroundColor = orig.content[index].textBackgroundColor
			change.content[index].textMarginTop = orig.content[index].textMarginTop
			change.content[index].textMarginBottom = orig.content[index].textMarginBottom
			change.content[index].textPadding = orig.content[index].textPadding
			change.content[index].blockBoxShadowX = orig.content[index].blockBoxShadowX
			change.content[index].blockBoxShadowY = orig.content[index].blockBoxShadowY
			change.content[index].blockBoxShadowBlur = orig.content[index].blockBoxShadowBlur
			change.content[index].blockBoxShadowColor = orig.content[index].blockBoxShadowColor
		}
	})

	return blockArray
}

export async function create_image_template(template, blockID, columnID, tag, blockArray) {
	//get the template values from array
	let change, tempValues
	blockArray.forEach((blocks) => {
		if (blocks.blockName === template[0]) {
			blocks.content.forEach((image) => {
				if (image.id === template[1]) {
					tempValues = [
						image.imageWidth,
						image.objectFit,
						image.boxShadowX,
						image.boxShadowY,
						image.boxShadowBlur,
						image.boxShadowColor,
						image.imageBorderTopRadius,
						image.imageBorderBottomRadius,
						image.imageBorderLeftWidth,
						image.imageBorderLeftStyle,
						image.imageBorderLeftColor,
						image.imageBorderTopWidth,
						image.imageBorderTopStyle,
						image.imageBorderTopColor,
						image.imageBorderRightWidth,
						image.imageBorderRightStyle,
						image.imageBorderRightColor,
						image.imageBorderBottomWidth,
						image.imageBorderBottomStyle,
						image.imageBorderBottomColor,
						image.imageMarginTop,
						image.imageMarginBottom,
						image.imagePadding,
					]
				}
			})
		}
	})

	//get
	blockArray.forEach((item) => {
		if (item.blockName === blockID) change = item
	})

	//content
	change.content.forEach((item, index) => {
		change.content[columnID - 1].imageWidth = tempValues[0]
		change.content[columnID - 1].objectFit = tempValues[1]
		change.content[columnID - 1].boxShadowX = tempValues[2]
		change.content[columnID - 1].boxShadowY = tempValues[3]
		change.content[columnID - 1].boxShadowBlur = tempValues[4]
		change.content[columnID - 1].boxShadowColor = tempValues[5]
		change.content[columnID - 1].imageBorderTopRadius = tempValues[6]
		change.content[columnID - 1].imageBorderBottomRadius = tempValues[7]
		change.content[columnID - 1].imageBorderLeftWidth = tempValues[8]
		change.content[columnID - 1].imageBorderLeftStyle = tempValues[9]
		change.content[columnID - 1].imageBorderLeftColor = tempValues[10]
		change.content[columnID - 1].imageBorderTopWidth = tempValues[11]
		change.content[columnID - 1].imageBorderTopStyle = tempValues[12]
		change.content[columnID - 1].imageBorderTopColor = tempValues[13]
		change.content[columnID - 1].imageBorderRightWidth = tempValues[14]
		change.content[columnID - 1].imageBorderRightStyle = tempValues[15]
		change.content[columnID - 1].imageBorderRightColor = tempValues[16]
		change.content[columnID - 1].imageBorderBottomWidth = tempValues[17]
		change.content[columnID - 1].imageBorderBottomStyle = tempValues[18]
		change.content[columnID - 1].imageBorderBottomColor = tempValues[19]
		change.content[columnID - 1].imageMarginTop = tempValues[20]
		change.content[columnID - 1].imageMarginBottom = tempValues[21]
		change.content[columnID - 1].imagePadding = tempValues[22]
	})

	return blockArray
}

export async function create_column_template(template, blockID, columnID, blockArray) {
	//get the template values from array
	let change, tempValues
	blockArray.forEach((blocks) => {
		if (blocks.blockName === template[0]) {
			blocks.content.forEach((column) => {
				if (column.id === template[1]) {
					tempValues = [
						column.padding,
						column.marginTop,
						column.marginBottom,
						column.backgroundColor,
						column.borderTopRadius,
						column.borderBottomRadius,
						column.borderBackgroundImage,
						column.borderTopWidth,
						column.borderTopStyle,
						column.borderTopColor,
						column.borderBottomWidth,
						column.borderBottomStyle,
						column.borderBottomColor,
						column.borderLeftWidth,
						column.borderLeftStyle,
						column.borderLeftColor,
						column.borderRightWidth,
						column.borderRightStyle,
						column.borderRightColor,
						column.backgroundImage,
						column.columnBoxShadowX,
						column.columnBoxShadowY,
						column.columnBoxShadowBlur,
						column.columnBoxShadowColor,
						column.titleWidth,
						column.titleAlignHorizontal,
						column.titleAlignVertical,
						column.titleFontFamily,
						column.titleFontSize,
						column.titleFontColor,
						column.titleFontWeight,
						column.titleFontStyle,
						column.titleFontDeco,
						column.titleBackgroundColor,
						column.titleMarginTop,
						column.titleMarginBottom,
						column.titlePadding,
						column.titleColumnBorderRadius,
						column.titleHeight,
						column.titlePosLeft,
						column.titlePosTop,
						column.textWidth,
						column.textAlignHorizontal,
						column.textAlignVertical,
						column.textFontFamily,
						column.textFontSize,
						column.textFontColor,
						column.textFontWeight,
						column.textFontStyle,
						column.textFontDeco,
						column.textBackgroundColor,
						column.textMarginTop,
						column.textMarginBottom,
						column.textPadding,
						column.textHeight,
						column.textPosLeft,
						column.textPosTop,
						column.imageWidth,
						column.imageMarginBottom,
						column.imageMarginTop,
					]
				}
			})
		}
	})

	blockArray.forEach((item) => {
		if (item.blockName === blockID) change = item
	})

	//content
	change.content.forEach((item, index) => {
		change.content[columnID - 1].padding = tempValues[0]
		change.content[columnID - 1].marginTop = tempValues[1]
		change.content[columnID - 1].marginBottom = tempValues[2]
		change.content[columnID - 1].backgroundColor = tempValues[3]
		change.content[columnID - 1].borderTopRadius = tempValues[4]
		change.content[columnID - 1].borderBottomRadius = tempValues[5]
		change.content[columnID - 1].borderBackgroundImage = tempValues[6]
		change.content[columnID - 1].borderTopWidth = tempValues[7]
		change.content[columnID - 1].borderTopStyle = tempValues[8]
		change.content[columnID - 1].borderTopColor = tempValues[9]
		change.content[columnID - 1].borderBottomWidth = tempValues[10]
		change.content[columnID - 1].borderBottomStyle = tempValues[11]
		change.content[columnID - 1].borderBottomColor = tempValues[12]
		change.content[columnID - 1].borderLeftWidth = tempValues[13]
		change.content[columnID - 1].borderLeftStyle = tempValues[14]
		change.content[columnID - 1].borderLeftColor = tempValues[15]
		change.content[columnID - 1].borderRightWidth = tempValues[16]
		change.content[columnID - 1].borderRightStyle = tempValues[17]
		change.content[columnID - 1].borderRightColor = tempValues[18]
		change.content[columnID - 1].backgroundImage = tempValues[19]
		change.content[columnID - 1].columnBoxShadowX = tempValues[20]
		change.content[columnID - 1].columnBoxShadowY = tempValues[21]
		change.content[columnID - 1].columnBoxShadowBlur = tempValues[22]
		change.content[columnID - 1].columnBoxShadowColor = tempValues[23]
		change.content[columnID - 1].titleWidth = tempValues[24]
		change.content[columnID - 1].titleAlignHorizontal = tempValues[25]
		change.content[columnID - 1].titleAlignVertical = tempValues[26]
		change.content[columnID - 1].titleFontFamily = tempValues[27]
		change.content[columnID - 1].titleFontSize = tempValues[28]
		change.content[columnID - 1].titleFontColor = tempValues[29]
		change.content[columnID - 1].titleFontWeight = tempValues[30]
		change.content[columnID - 1].titleFontStyle = tempValues[31]
		change.content[columnID - 1].titleFontDeco = tempValues[32]
		change.content[columnID - 1].titleBackgroundColor = tempValues[33]
		change.content[columnID - 1].titleMarginTop = tempValues[34]
		change.content[columnID - 1].titleMarginBottom = tempValues[35]
		change.content[columnID - 1].titlePadding = tempValues[36]
		change.content[columnID - 1].titleColumnBorderRadius = tempValues[37]
		change.content[columnID - 1].titleHeight = tempValues[38]
		change.content[columnID - 1].titlePosLeft = tempValues[39]
		change.content[columnID - 1].titlePosTop = tempValues[40]
		change.content[columnID - 1].textWidth = tempValues[41]
		change.content[columnID - 1].textAlignHorizontal = tempValues[42]
		change.content[columnID - 1].textAlignVertical = tempValues[43]
		change.content[columnID - 1].textFontFamily = tempValues[44]
		change.content[columnID - 1].textFontSize = tempValues[45]
		change.content[columnID - 1].textFontColor = tempValues[46]
		change.content[columnID - 1].textFontWeight = tempValues[47]
		change.content[columnID - 1].textFontStyle = tempValues[48]
		change.content[columnID - 1].textFontDeco = tempValues[49]
		change.content[columnID - 1].textBackgroundColor = tempValues[50]
		change.content[columnID - 1].textMarginTop = tempValues[51]
		change.content[columnID - 1].textMarginBottom = tempValues[52]
		change.content[columnID - 1].textPadding = tempValues[53]
		change.content[columnID - 1].textHeight = tempValues[54]
		change.content[columnID - 1].textPosLeft = tempValues[55]
		change.content[columnID - 1].textPosTop = tempValues[56]
		change.content[columnID - 1].imageWidth = tempValues[57]
		change.content[columnID - 1].imageMarginBottom = tempValues[58]
		change.content[columnID - 1].imageMarginTop = tempValues[59]
	})

	return blockArray
}

export function string_to_fontsize(fs) {
	const fsXXL = 'clamp(0.8rem, 5.8vw, 5rem)'
	const fsXL = 'clamp(0.8rem, 4.1vw, 3.5rem)'
	const fsX = 'clamp(0.6rem, 2.3vw, 2rem)'
	const fsL = 'clamp(0.6rem, 1.5vw, 1.3rem)'
	const fsN = 'clamp(0.4rem, 1.1vw, 1rem)'
	const fsS = 'clamp(0.4rem, 1vw, 0.9rem)'
	const fsXS = 'clamp(0.4rem, 0.9vw, 0.7rem)'
	let returnFont
	switch (fs) {
		case 'X-SMALL':
			returnFont = fsXS
			break

		case 'SMALL':
			returnFont = fsS
			break

		case 'NORMAL':
			returnFont = fsN
			break

		case 'LARGE':
			returnFont = fsL
			break

		case 'X-LARGE':
			returnFont = fsX
			break

		case 'XX-LARGE':
			returnFont = fsXL
			break

		case 'XXX-LARGE':
			returnFont = fsXXL
			break
	}

	return returnFont
}

export async function resize_image(cmd, url, username, data) {
	const cropCmd = data.cropCmd
	let canvas = document.createElement('canvas')
	canvas.width = data.x
	canvas.height = data.y
	let ctx = canvas.getContext('2d')
	let image = new Image()
	image.setAttribute('crossorigin', 'anonymous')
	image.src = url + '/' + data.blockname + '/large/' + data.image

	image.onload = async () => {
		if (cropCmd === 'crop') ctx.drawImage(image, data.marginLeft, data.marginTop, data.x, data.y, 0, 0, data.x, data.y)

		if (cropCmd === 'resize') ctx.drawImage(image, 0, 0, data.x, data.y)

		const imgEncoded = ctx.canvas.toDataURL(url + '/' + data.blockname + '/large/' + data.image, 1)
		data.imageEncoded = imgEncoded

		const response = await send_resize(cmd, username, data)
		if (response) {
			storeImageModal.set(false)
		}
	}
}

export async function get_image_size(path) {
	const response = await fetch(urlAdmin, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ cmd: 'get_image_size', path: path }),
	})

	const dataResponse = await response.json()
	return [dataResponse[0], dataResponse[1]]
}

export function fontsize_to_string(fs) {
	let returnStr
	let compstr = fs.split(',')[1]
	compstr = parseFloat(compstr.split('v')[0])

	switch (compstr) {
		case 0.9:
			returnStr = 'X-SMALL'
			break

		case 1:
			returnStr = 'SMALL'
			break

		case 1.1:
			returnStr = 'NORMAL'
			break

		case 1.5:
			returnStr = 'LARGE'
			break

		case 2.3:
			returnStr = 'X-LARGE'
			break

		case 4.1:
			returnStr = 'XX-LARGE'
			break

		case 5.8:
			returnStr = 'XX-LARGE'
			break
	}

	return returnStr
}

async function send_resize(cmd, username, data) {
	try {
		const response = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ cmd: cmd, username: username, data: data }),
		})
		const dataResponse = await response.json()
		return dataResponse
	} catch (e) {
		return { sent: false, code: 'ERROR: es konnte keine Verbindung hergestellt werden', error: e }
	}
}

function get_site_settings(config) {
	const bgOpacity = config.body.split(',')
	const bgOpac = bgOpacity[3].slice(0, bgOpacity[3].length - 1)
	return [config.body, bgOpac]
}

function get_navbar_settings(configFile) {
	let navLayoutOrder,
		navPosition,
		navWidth,
		navValign,
		navAlign,
		navMarginBottom,
		navMarginTop,
		navPaddingLeft,
		navPaddingRight,
		navBGcolor,
		navFontSize,
		navFontWeight,
		navFontColor,
		navFontHover,
		navBorderTopWidth,
		navBorderTopColor,
		navBorderTopStyle,
		navBorderBottomWidth,
		navBorderBottomColor,
		navBorderBottomStyle,
		navShadowColor,
		navShadowOffsetY,
		navShadowBlur,
		navTTBG,
		navTTFC,
		navHSC,
		navHFC,
		navHPOP

	configFile.blocks.forEach((block, index) => {
		if (block.blockName === 'navbar') {
			navLayoutOrder = configFile.blocks[index].layoutOrder
			navPosition = configFile.blocks[index].position
			navWidth = configFile.blocks[index].width
			navValign = configFile.blocks[index].valign
			navAlign = configFile.blocks[index].align
			navMarginBottom = configFile.blocks[index].marginBottom
			navMarginTop = configFile.blocks[index].marginTop
			navPaddingLeft = configFile.blocks[index].paddingLeft
			navPaddingRight = configFile.blocks[index].paddingRight
			navBGcolor = configFile.blocks[index].backgroundColor
			navFontSize = fontsize_to_string(configFile.blocks[index].fontSize)
			navFontWeight = configFile.blocks[index].fontWeight
			navFontColor = configFile.blocks[index].fontColor
			navFontHover = configFile.blocks[index].fontHover
			navBorderTopWidth = configFile.blocks[index].borderTopWidth
			navBorderTopColor = configFile.blocks[index].borderTopColor
			navBorderTopStyle = configFile.blocks[index].borderTopStyle
			navBorderBottomWidth = configFile.blocks[index].borderBottomWidth
			navBorderBottomColor = configFile.blocks[index].borderBottomColor
			navBorderBottomStyle = configFile.blocks[index].borderBottomStyle
			navShadowColor = configFile.blocks[index].shadowColor
			navShadowOffsetY = configFile.blocks[index].shadowOffsetY
			navShadowBlur = configFile.blocks[index].shadowBlur
			navTTBG = configFile.blocks[index].ttBG
			navTTFC = configFile.blocks[index].ttFC
			navHSC = configFile.blocks[index].HSC
			navHFC = configFile.blocks[index].HFC
			navHPOP = configFile.blocks[index].HPOP
		}
	})

	const navOpacArr = navBGcolor.split(',')
	const navOpac = navOpacArr[3].slice(0, navOpacArr[3].length - 1)
	const navOpacSArray = navShadowColor.split(',')
	const navOpacShadow = navOpacSArray[3].slice(0, navOpacSArray[3].length - 1)
	const navFontSArray = navFontColor.split(',')
	const navFontOpac = navFontSArray[3].slice(0, navFontSArray[3].length - 1)
	const navFontHoverArray = navFontHover.split(',')
	const navHoverOpac = navFontHoverArray[3].slice(0, navFontHoverArray[3].length - 1)

	return [
		navLayoutOrder,
		navPosition,
		navWidth,
		navValign,
		navAlign,
		navMarginBottom,
		navMarginTop,
		navPaddingLeft,
		navPaddingRight,
		navBGcolor,
		navOpac,
		navFontSize,
		navFontWeight,
		navFontColor,
		navFontOpac,
		navFontHover,
		navHoverOpac,
		navBorderTopWidth,
		navBorderTopColor,
		navBorderTopStyle,
		navBorderBottomWidth,
		navBorderBottomColor,
		navBorderBottomStyle,
		navShadowColor,
		navShadowOffsetY,
		navShadowBlur,
		navOpacShadow,
		navTTBG,
		navTTFC,
		navHSC,
		navHFC,
		navHPOP,
	]
}

function get_contact_settings(blocks) {
	let buttonBg,
		buttonBorderColor,
		buttonBorderRadius,
		buttonBorderWidth,
		buttonFontColor,
		buttonFontHover,
		buttonFontFamily,
		buttonFontSize,
		buttonHover,
		buttonText,
		cityText,
		containerLeftBg,
		containerRightBg,
		containerLeftPaddingTop,
		containerLeftPaddingBottom,
		containerRightPaddingTop,
		containerRightPaddingBottom,
		countryText,
		emailText,
		sibHeight,
		infoAddressColor,
		infoAddressFontSize,
		infoAddressMarginBottom,
		infoAddressWeight,
		infoAddressStyle,
		infoContactColor,
		infoContactFontFamily,
		infoContactFontSize,
		infoLeftPadding,
		infoNameColor,
		infoNameFontFamily,
		infoAddressFontFamily,
		infoNameFontSize,
		infoNameMarginBottom,
		infoNameStyle,
		infoNameWeight,
		infoNameDeco,
		marginTop,
		marginBottom,
		inputBg,
		inputFocus,
		inputBorder,
		inputFontColor,
		inputFontFamily,
		inputFontSize,
		inputShadowBlur,
		inputShadowColor,
		inputShadowX,
		inputShadowY,
		layoutOrder,
		map,
		nameText,
		padding,
		phoneText,
		streetText,
		titleAlign,
		titleBackgroundColor,
		titleColor,
		titleFontFamily,
		titleFontSize,
		titleFontStyle,
		titleFontWeight,
		titleFontDeco,
		titlePadding,
		titleText,
		shadowColor,
		shadowX,
		shadowY,
		shadowBlur,
		infoContactLeftColor,
		infoContactLeftStyle,
		infoContactLeftWeight,
		infoContactRightColor,
		infoContactRightStyle,
		infoContactRightWeight,
		mapHeight,
		mapWidth,
		mapBgColor,
		mapBorderColor,
		mapBorderStyle,
		mapBorderWidth,
		mapShadowColor,
		mapShadowX,
		mapShadowY,
		mapShadowBlur,
		tSX,
		tSY,
		tSB,
		tSC,
		borderTopRadius,
		borderBottomRadius,
		borderLeftWidth,
		borderLeftStyle,
		borderLeftColor,
		borderTopWidth,
		borderTopStyle,
		borderTopColor,
		borderRightWidth,
		borderRightStyle,
		borderRightColor,
		borderBottomWidth,
		borderBottomStyle,
		borderBottomColor,
		titleMT,
		titleMB,
		titleHeight,
		titleValign

	blocks.forEach((block) => {
		if (block.blockName === 'contact') {
			buttonBg = block.buttonBg
			buttonBorderColor = block.buttonBorderColor
			buttonBorderRadius = block.buttonBorderRadius
			buttonBorderWidth = block.buttonBorderWidth
			buttonFontColor = block.buttonFontColor
			buttonFontHover = block.buttonFontHover
			buttonFontFamily = block.buttonFontFamily
			buttonFontSize = fontsize_to_string(block.buttonFontSize)
			buttonHover = block.buttonHover
			buttonText = block.buttonText
			cityText = block.cityText
			containerLeftBg = block.containerLeftBg
			containerRightBg = block.containerRightBg
			containerLeftPaddingTop = block.containerLeftPaddingTop
			containerLeftPaddingBottom = block.containerLeftPaddingBottom
			containerRightPaddingTop = block.containerRightPaddingTop
			containerRightPaddingBottom = block.containerRightPaddingBottom
			countryText = block.countryText
			countryText = block.countryText
			sibHeight = block.sibHeight
			infoAddressColor = block.infoAddressColor
			infoAddressFontFamily = block.infoAddressFontFamily
			infoAddressFontSize = fontsize_to_string(block.infoAddressFontSize)
			infoAddressMarginBottom = block.infoAddressMarginBottom
			infoAddressWeight = block.infoAddressWeight
			infoAddressStyle = block.infoAddressStyle
			infoContactColor = block.infoContactColor
			infoContactFontFamily = block.infoContactFontFamily
			infoContactFontSize = fontsize_to_string(block.infoContactFontSize)
			infoLeftPadding = block.infoLeftPadding
			infoNameColor = block.infoNameColor
			infoNameFontFamily = block.infoNameFontFamily
			infoNameFontSize = fontsize_to_string(block.infoNameFontSize)
			infoNameMarginBottom = block.infoNameMarginBottom
			infoNameStyle = block.infoNameStyle
			infoNameWeight = block.infoNameWeight
			infoNameDeco = block.infoNameDeco
			marginTop = block.marginTop
			marginBottom = block.marginBottom
			inputBg = block.inputBg
			inputFocus = block.inputFocus
			inputBorder = block.inputBorder
			inputFontColor = block.inputFontColor
			inputFontFamily = block.inputFontFamily
			inputFontSize = fontsize_to_string(block.inputFontSize)
			inputShadowBlur = block.inputShadowBlur
			inputShadowColor = block.inputShadowColor
			inputShadowX = block.inputShadowX
			inputShadowY = block.inputShadowY
			layoutOrder = block.layoutOrder
			map = block.map
			nameText = block.nameText
			padding = block.padding
			phoneText = block.phoneText
			streetText = block.streetText
			titleAlign = block.titleAlign
			titleBackgroundColor = block.titleBackgroundColor
			titleColor = block.titleColor
			titleFontFamily = block.titleFontFamily
			titleFontSize = fontsize_to_string(block.titleFontSize)
			titleFontStyle = block.titleFontStyle
			titleFontWeight = block.titleFontWeight
			titleFontDeco = block.titleFontDeco
			titlePadding = block.titlePadding
			titleText = block.titleText
			shadowColor = block.shadowColor
			shadowX = block.shadowX
			shadowY = block.shadowY
			shadowBlur = block.shadowBlur
			infoContactLeftColor = block.infoContactLeftColor
			infoContactLeftStyle = block.infoContactLeftStyle
			infoContactLeftWeight = block.infoContactLeftWeight
			infoContactRightColor = block.infoContactRightColor
			infoContactRightStyle = block.infoContactRightStyle
			infoContactRightWeight = block.infoContactRightWeight
			mapHeight = block.mapHeight
			mapWidth = block.mapWidth
			mapBgColor = block.mapBackgroundColor
			mapBorderColor = block.mapBorderColor
			mapBorderStyle = block.mapBorderStyle
			mapBorderWidth = block.mapBorderWidth
			mapShadowColor = block.mapShadowColor
			mapShadowX = block.mapShadowX
			mapShadowY = block.mapShadowY
			mapShadowBlur = block.mapShadowBlur
			tSX = block.titleShadowX
			tSY = block.titleShadowY
			tSB = block.titleShadowBlur
			tSC = block.titleShadowColor
			borderTopRadius = block.borderTopRadius
			borderBottomRadius = block.borderBottomRadius
			borderLeftWidth = block.borderLeftWidth
			borderLeftStyle = block.borderLeftStyle
			borderLeftColor = block.borderLeftColor
			borderTopWidth = block.borderTopWidth
			borderTopStyle = block.borderTopStyle
			borderTopColor = block.borderTopColor
			borderRightWidth = block.borderRightWidth
			borderRightStyle = block.borderRightStyle
			borderRightColor = block.borderRightColor
			borderBottomWidth = block.borderBottomWidth
			borderBottomStyle = block.borderBottomStyle
			borderBottomColor = block.borderBottomColor
			titleMB = block.titleMB
			titleMT = block.titleMT
			titleHeight = block.titleHeight
			titleValign = block.titleValign
		}
	})
	const titleBgOpacity = titleBackgroundColor.split(',')
	const titleBgOpac = titleBgOpacity[3].slice(0, titleBgOpacity[3].length - 1)
	const containerLeftOpacity = containerLeftBg.split(',')
	const containerLeftOpac = containerLeftOpacity[3].slice(0, containerLeftOpacity[3].length - 1)
	const containerRightOpacity = containerRightBg.split(',')
	const containerRightOpac = containerRightOpacity[3].slice(0, containerRightOpacity[3].length - 1)
	const mapBgOpacity = mapBgColor.split(',')
	const mapBgOpac = mapBgOpacity[3].slice(0, mapBgOpacity[3].length - 1)
	return [
		buttonBg,
		buttonBorderColor,
		buttonBorderRadius,
		buttonBorderWidth,
		buttonFontColor,
		buttonFontHover,
		buttonFontFamily,
		buttonFontSize,
		buttonHover,
		buttonText,
		cityText,
		containerLeftBg,
		containerRightBg,
		containerLeftPaddingTop,
		containerLeftPaddingBottom,
		containerRightPaddingTop,
		containerRightPaddingBottom,
		countryText,
		emailText,
		sibHeight,
		infoAddressColor,
		infoAddressFontFamily,
		infoAddressFontSize,
		infoAddressMarginBottom,
		infoAddressWeight,
		infoAddressStyle,
		infoContactColor,
		infoContactFontFamily,
		infoContactFontSize,
		infoLeftPadding,
		infoNameColor,
		infoNameFontFamily,
		infoNameFontSize,
		infoNameMarginBottom,
		infoNameStyle,
		infoNameWeight,
		infoNameDeco,
		marginTop,
		marginBottom,
		inputBg,
		inputFocus,
		inputBorder,
		inputFontColor,
		inputFontFamily,
		inputFontSize,
		inputShadowBlur,
		inputShadowColor,
		inputShadowX,
		inputShadowY,
		layoutOrder,
		map,
		nameText,
		padding,
		phoneText,
		streetText,
		titleAlign,
		titleBackgroundColor,
		titleColor,
		titleFontFamily,
		titleFontSize,
		titleFontStyle,
		titleFontWeight,
		titleFontDeco,
		titlePadding,
		titleText,
		titleBgOpac,
		containerLeftOpac,
		shadowColor,
		shadowX,
		shadowY,
		shadowBlur,
		containerRightOpac,
		infoContactLeftColor,
		infoContactLeftStyle,
		infoContactLeftWeight,
		infoContactRightColor,
		infoContactRightStyle,
		infoContactRightWeight,
		mapHeight,
		mapWidth,
		mapBgColor,
		mapBgOpac,
		mapBorderColor,
		mapBorderStyle,
		mapBorderWidth,
		mapShadowColor,
		mapShadowX,
		mapShadowY,
		mapShadowBlur,
		tSX,
		tSY,
		tSB,
		tSC,
		borderTopRadius,
		borderBottomRadius,
		borderLeftWidth,
		borderLeftStyle,
		borderLeftColor,
		borderTopWidth,
		borderTopStyle,
		borderTopColor,
		borderRightWidth,
		borderRightStyle,
		borderRightColor,
		borderBottomWidth,
		borderBottomStyle,
		borderBottomColor,
		titleMB,
		titleMT,
		titleHeight,
		titleValign,
	]
}

function get_gallery_settings(blocks) {
	let lPadding,
		lMarginTop,
		lMarginBottom,
		lBgColor,
		lBTLradius,
		lBTRradius,
		lBBLradius,
		lBBRradius,
		lBbgImage,
		lBLwidth,
		lBLstyle,
		lBLcolor,
		lBLTwidth,
		lBLTstyle,
		lBLTcolor,
		lBLRwidth,
		lBLRstyle,
		lBLRcolor,
		lBBLwidth,
		lBBLstyle,
		lBBLcolor,
		introFontColor,
		introFontFamily,
		introFontSize,
		introFontWeight,
		introFontStyle,
		introFontAlign,
		introFontValign,
		rPadding,
		rMarginTop,
		rMarginBottom,
		rBgColor,
		rBTLradius,
		rBTRradius,
		rBBLradius,
		rBBRradius,
		rBbgImage,
		rBLwidth,
		rBLstyle,
		rBLcolor,
		rBLTwidth,
		rBLTstyle,
		rBLTcolor,
		rBLRwidth,
		rBLRstyle,
		rBLRcolor,
		rBBLwidth,
		rBBLstyle,
		rBBLcolor,
		rAlign,
		rValign,
		sBgColor,
		sBgY,
		sBgBlur,
		sLeftColor,
		sLeftOffsetX,
		sLeftOffssetY,
		sLeftBlur,
		sRightColor,
		sRightOffsetX,
		sRightOffssetY,
		sRightBlur,
		modalSliderWidth,
		modalSliderHeight,
		modalBLwidth,
		modalBTwidth,
		modalBRwidth,
		modalBBwidth,
		modalBTradius,
		modalBBradius,
		modalShadowColor,
		modalShadowX,
		modalShadowY,
		modalShadowB,
		modalTitleBGColor,
		modalTitleWidth,
		modalTitleHeight,
		modalTitleLeft,
		modalTitleTop,
		modalTBLwidth,
		modalTBTwidth,
		modalTBRwidth,
		modalTBBwidth,
		modalTTradius,
		modalTBradius,
		modalTScolor,
		modalTSX,
		modalTSY,
		modalTSB,
		modalTFC,
		modalTFF,
		modalTFS,
		modalTFST,
		modalTFW,
		modalTextBGColor,
		modalTextBGOpac,
		modalTextWidth,
		modalTextHeight,
		modalTextLeft,
		modalTextTop,
		modalTXTBLwidth,
		modalTXTBTwidth,
		modalTXTBRwidth,
		modalTXTBBwidth,
		modalTXTTradius,
		modalTXTBradius,
		modalTXTScolor,
		modalTXTSX,
		modalTXTSY,
		modalTXTSB,
		modalTXTFC,
		modalTXTFF,
		modalTXTFS,
		modalTXTFST,
		modalTXTFW,
		modalTDeco,
		modalBG,
		modalC,
		modalChover

	blocks.forEach((block) => {
		if (block.blockName === 'gallery') {
			lPadding = block.galleryLeftPadding
			lMarginTop = block.galleryLeftMarginTop
			lMarginBottom = block.galleryLeftMarginBottom
			lBgColor = block.galleryLeftBackgroundColor
			lBTLradius = block.galleryLeftBorderTopRadius
			lBTRradius = block.galleryLeftBorderTopRadius
			lBBLradius = block.galleryLeftBorderBottomRadius
			lBBRradius = block.galleryLeftBorderBottomRadius
			lBbgImage = block.galleryLeftBorderBackgroundImage
			lBLwidth = block.galleryLeftBorderLeftWidth
			lBLstyle = block.galleryLeftBorderLeftStyle
			lBLcolor = block.galleryLeftBorderLeftColor
			lBLTwidth = block.galleryLeftBorderTopWidth
			lBLTstyle = block.galleryLeftBorderTopStyle
			lBLTcolor = block.galleryLeftBorderTopColor
			lBLRwidth = block.galleryLeftBorderRightWidth
			lBLRstyle = block.galleryLeftBorderRightStyle
			lBLRcolor = block.galleryLeftBorderRightColor
			lBBLwidth = block.galleryLeftBorderBottomWidth
			lBBLstyle = block.galleryLeftBorderBottomStyle
			lBBLcolor = block.galleryLeftBorderBottomColor
			introFontColor = block.introFontColor
			introFontFamily = block.introFontFamily
			introFontSize = fontsize_to_string(block.introFontSize)
			introFontWeight = block.introFontWeight
			introFontStyle = block.introFontStyle
			introFontAlign = block.galleryLeftAlign
			introFontValign = block.galleryLeftValign
			rPadding = block.galleryRightPadding
			rMarginTop = block.galleryRightMarginTop
			rMarginBottom = block.galleryRightMarginBottom
			rBgColor = block.galleryRightBackgroundColor
			rBTLradius = block.galleryRightBorderTopRadius
			rBTRradius = block.galleryRightBorderTopRadius
			rBBLradius = block.galleryRightBorderBottomRadius
			rBBRradius = block.galleryRightBorderBottomRadius
			rBbgImage = block.galleryRightBorderBackgroundImage
			rBLwidth = block.galleryRightBorderLeftWidth
			rBLstyle = block.galleryRightBorderLeftStyle
			rBLcolor = block.galleryRightBorderLeftColor
			rBLTwidth = block.galleryRightBorderTopWidth
			rBLTstyle = block.galleryRightBorderTopStyle
			rBLTcolor = block.galleryRightBorderTopColor
			rBLRwidth = block.galleryRightBorderRightWidth
			rBLRstyle = block.galleryRightBorderRightStyle
			rBLRcolor = block.galleryRightBorderRightColor
			rBBLwidth = block.galleryRightBorderBottomWidth
			rBBLstyle = block.galleryRightBorderBottomStyle
			rBBLcolor = block.galleryRightBorderBottomColor
			rAlign = block.galleryRightAlign
			rValign = block.galleryRightValign
			sBgColor = block.galleryShadowColor
			sBgY = block.galleryShadowY
			sBgBlur = block.galleryShadowBlur
			sLeftColor = block.galleryLeftShadowColor
			sLeftOffsetX = block.galleryLeftShadowOffsetX
			sLeftOffssetY = block.galleryLeftShadowOffsetY
			sLeftBlur = block.galleryLeftShadowBlur
			sRightColor = block.galleryRightShadowColor
			sRightOffsetX = block.galleryRightShadowOffsetX
			sRightOffssetY = block.galleryRightShadowOffsetY
			sRightBlur = block.galleryRightShadowBlur
			modalSliderWidth = block.sliderWidth
			modalSliderHeight = block.sliderHeight
			modalBLwidth = block.sliderBLwidth
			modalBTwidth = block.sliderBTwidth
			modalBRwidth = block.sliderBRwidth
			modalBBwidth = block.sliderBBwidth
			modalBTradius = block.sliderBTradius
			modalBBradius = block.sliderBBradius
			modalShadowColor = block.sliderShadowColor
			modalShadowX = block.sliderShadowOffsetX
			modalShadowY = block.sliderShadowOffsetY
			modalShadowB = block.sliderShadowBlur
			modalTitleBGColor = block.sliderInsetTitleBg
			modalTitleWidth = block.sliderInsetTitleWidth
			modalTitleHeight = block.sliderInsetTitleHeight
			modalTitleLeft = block.sliderInsetTitleLeft
			modalTitleTop = block.sliderInsetTitleTop
			modalTBLwidth = block.sliderInsetTitleBLwidth
			modalTBTwidth = block.sliderInsetTitleBTwidth
			modalTBRwidth = block.sliderInsetTitleBRwidth
			modalTBBwidth = block.sliderInsetTitleBBwidth
			modalTTradius = block.sliderInsetTitleBTradius
			modalTBradius = block.sliderInsetTitleBBradius
			modalTScolor = block.sliderInsetTitleShadowColor
			modalTSX = block.sliderInsetTitleShadowOffsetX
			modalTSY = block.sliderInsetTitleShadowOffsetY
			modalTSB = block.sliderInsetTitleShadowBlur
			modalTFC = block.sliderInsetTitleColor
			modalTFF = block.sliderInsetTitleFont
			modalTFS = fontsize_to_string(block.sliderInsetTitleSize)
			modalTFST = block.sliderInsetTitleStyle
			modalTFW = block.sliderInsetTitleWeight
			modalTDeco = block.sliderInsetTitleDeco
			modalBG = block.modalBackground
			modalTextBGColor = block.sliderInsetTextBg
			modalTextWidth = block.sliderInsetTextWidth
			modalTextHeight = block.sliderInsetTextHeight
			modalTextLeft = block.sliderInsetTextLeft
			modalTextTop = block.sliderInsetTextTop
			modalTXTBLwidth = block.sliderInsetTextBLwidth
			modalTXTBTwidth = block.sliderInsetTextBTwidth
			modalTXTBRwidth = block.sliderInsetTextBRwidth
			modalTXTBBwidth = block.sliderInsetTextBBwidth
			modalTXTTradius = block.sliderInsetTextBTradius
			modalTXTBradius = block.sliderInsetTextBBradius
			modalTXTScolor = block.sliderInsetTextShadowColor
			modalTXTSX = block.sliderInsetTextShadowOffsetX
			modalTXTSY = block.sliderInsetTextShadowOffsetY
			modalTXTSB = block.sliderInsetTextShadowBlur
			modalTXTFC = block.sliderInsetTextColor
			modalTXTFF = block.sliderInsetTextFont
			modalTXTFS = fontsize_to_string(block.sliderInsetTextSize)
			modalTXTFST = block.sliderInsetTextStyle
			modalTXTFW = block.sliderInsetTextWeight
			modalC = block.modalArrows
			modalChover = block.modalArrowsHover
		}
	})

	const lBgOpacS = lBgColor.split(',')
	const lBgOpac = lBgOpacS[3].slice(0, lBgOpacS[3].length - 1)
	const rBgOpacS = rBgColor.split(',')
	const rBgOpac = rBgOpacS[3].slice(0, rBgOpacS[3].length - 1)
	const lBopacS = rBLcolor.split(',')
	const lBopac = lBopacS[3].slice(0, lBopacS[3].length - 1)
	const lFopacS = introFontColor.split(',')
	const lFopac = lFopacS[3].slice(0, lFopacS[3].length - 1)
	const sBgOpacity = sBgColor.split(',')
	const sBgOpac = sBgOpacity[3].slice(0, sBgOpacity[3].length - 1)
	const sLeftOpacity = sLeftColor.split(',')
	const sLeftOpac = sLeftOpacity[3].slice(0, sLeftOpacity[3].length - 1)
	const sRightOpacity = sRightColor.split(',')
	const sRightOpac = sRightOpacity[3].slice(0, sRightOpacity[3].length - 1)
	const mTitleBGOpacity = modalTitleBGColor.split(',')
	const modalTitleBGOpac = mTitleBGOpacity[3].slice(0, mTitleBGOpacity[3].length - 1)
	const mTSOpacity = modalTScolor.split(',')
	const modalTitleShadowOpac = mTSOpacity[3].slice(0, mTSOpacity[3].length - 1)
	const modalTFCOpacity = modalTFC.split(',')
	const modalTFCopac = modalTFCOpacity[3].slice(0, modalTFCOpacity[3].length - 1)
	const mTXTSOpacity = modalTXTScolor.split(',')
	const modalTextShadowOpac = mTXTSOpacity[3].slice(0, mTXTSOpacity[3].length - 1)
	const modalTXTFCOpacity = modalTXTFC.split(',')
	const modalTextFCopac = modalTXTFCOpacity[3].slice(0, modalTXTFCOpacity[3].length - 1)
	const modalBGOpacity = modalBG.split(',')
	const modalBgOpac = modalBGOpacity[3].slice(0, modalBGOpacity[3].length - 1)

	return [
		lPadding,
		lMarginTop,
		lMarginBottom,
		lBgColor,
		lBgOpac,
		lBTLradius,
		lBTRradius,
		lBBLradius,
		lBBRradius,
		lBbgImage,
		lBLwidth,
		lBLstyle,
		lBLcolor,
		lBLTwidth,
		lBLTstyle,
		lBLTcolor,
		lBLRwidth,
		lBLRstyle,
		lBLRcolor,
		lBBLwidth,
		lBBLstyle,
		lBBLcolor,
		lBopac,
		introFontColor,
		lFopac,
		introFontFamily,
		introFontSize,
		introFontWeight,
		introFontStyle,
		introFontAlign,
		introFontValign,
		rPadding,
		rMarginTop,
		rMarginBottom,
		rBgColor,
		rBgOpac,
		rBTLradius,
		rBTRradius,
		rBBLradius,
		rBBRradius,
		rBbgImage,
		rBLwidth,
		rBLstyle,
		rBLcolor,
		rBLTwidth,
		rBLTstyle,
		rBLTcolor,
		rBLRwidth,
		rBLRstyle,
		rBLRcolor,
		rBBLwidth,
		rBBLstyle,
		rBBLcolor,
		rAlign,
		rValign,
		sBgColor,
		sBgOpac,
		sBgY,
		sBgBlur,
		sLeftColor,
		sLeftOpac,
		sLeftOffsetX,
		sLeftOffssetY,
		sLeftBlur,
		sRightColor,
		sRightOpac,
		sRightOffsetX,
		sRightOffssetY,
		sRightBlur,
		modalSliderWidth,
		modalSliderHeight,
		modalBLwidth,
		modalBTwidth,
		modalBRwidth,
		modalBBwidth,
		modalBTradius,
		modalBBradius,
		modalShadowColor,
		modalShadowX,
		modalShadowY,
		modalShadowB,
		modalTitleBGColor,
		modalTitleBGOpac,
		modalTitleWidth,
		modalTitleHeight,
		modalTitleLeft,
		modalTitleTop,
		modalTBLwidth,
		modalTBTwidth,
		modalTBRwidth,
		modalTBBwidth,
		modalTTradius,
		modalTBradius,
		modalTScolor,
		modalTitleShadowOpac,
		modalTSX,
		modalTSY,
		modalTSB,
		modalTFC,
		modalTFCopac,
		modalTFF,
		modalTFS,
		modalTFST,
		modalTFW,
		modalTDeco,
		modalTextBGColor,
		modalTextBGOpac,
		modalTextWidth,
		modalTextHeight,
		modalTextLeft,
		modalTextTop,
		modalTXTBLwidth,
		modalTXTBTwidth,
		modalTXTBRwidth,
		modalTXTBBwidth,
		modalTXTTradius,
		modalTXTBradius,
		modalTXTScolor,
		modalTextShadowOpac,
		modalTXTSX,
		modalTXTSY,
		modalTXTSB,
		modalTXTFC,
		modalTextFCopac,
		modalTXTFF,
		modalTXTFS,
		modalTXTFST,
		modalTXTFW,
		modalBG,
		modalBgOpac,
		modalC,
		modalChover,
	]
}

function get_block_settings(blocks, blockID) {
	let bgColor,
		mTop,
		mBottom,
		padding,
		blWidth,
		blColor,
		btWidth,
		btColor,
		brWidth,
		brColor,
		bbWidth,
		bbColor,
		btRadius,
		bbRadius,
		boxShadowY,
		boxShadowBlur,
		boxShadowColor,
		gridGap

	blocks.forEach((block) => {
		if (block.blockName === blockID) {
			bgColor = block.backgroundColor
			mTop = block.marginTop
			mBottom = block.marginBottom
			padding = block.padding
			blWidth = block.borderLeftWidth
			blColor = block.borderLeftColor
			btWidth = block.borderTopWidth
			btColor = block.borderTopColor
			brWidth = block.borderRightWidth
			brColor = block.borderRightColor
			bbWidth = block.borderBottomWidth
			bbColor = block.borderBottomColor
			btRadius = block.borderTopRadius
			bbRadius = block.borderBottomRadius
			boxShadowY = block.blockBoxShadowY
			boxShadowBlur = block.blockBoxShadowBlur
			boxShadowColor = block.blockBoxShadowColor
			gridGap = block.blockGridGap
		}
	})

	const bgOpacity = bgColor.split(',')
	const bgOpac = bgOpacity[3].slice(0, bgOpacity[3].length - 1)
	const sOpacity = boxShadowColor.split(',')
	const sOpac = sOpacity[3].slice(0, sOpacity[3].length - 1)
	return [
		bgColor,
		bgOpac,
		mTop,
		mBottom,
		padding,
		blWidth,
		blColor,
		btWidth,
		btColor,
		brWidth,
		brColor,
		bbWidth,
		bbColor,
		btRadius,
		bbRadius,
		boxShadowY,
		boxShadowBlur,
		boxShadowColor,
		sOpac,
		gridGap,
	]
}

function get_single_image_block_settings(blocks, blockID) {
	let height,
		bgColor,
		mTop,
		mBottom,
		padding,
		blWidth,
		blColor,
		btWidth,
		btColor,
		brWidth,
		brColor,
		bbWidth,
		bbColor,
		btRadius,
		bbRadius,
		boxShadowY,
		boxShadowBlur,
		boxShadowColor,
		imageWidth,
		imageHeight,
		imageLeft,
		imageTop,
		bilWidth,
		bilColor,
		bitWidth,
		bitColor,
		birWidth,
		birColor,
		bibWidth,
		bibColor,
		bitRadius,
		bibRadius,
		biSBColor,
		biSBoffsetX,
		bisSBoffsetY,
		bisSBblur,
		biTitleFontColor,
		biTitleBgColor,
		biTitleWidth,
		biTitleHeight,
		biTitleLeft,
		biTitleTop,
		biTitleFontFamily,
		biTitleFontSize,
		biTitleLWidth,
		biTitleLColor,
		biTitleTWidth,
		biTitleTColor,
		biTitleRWidth,
		biTitleRColor,
		biTitleBWidth,
		biTitleBColor,
		biTitleBTradius,
		biTitleBBradius,
		biTitleScolor,
		biTitleShadowOffsetX,
		biTitleShadowOffsetY,
		biTitleShadowBlur,
		biTextWidth,
		biTextHeight,
		biTextLeft,
		biTextTop,
		biTextLWidth,
		biTextLColor,
		biTextTWidth,
		biTextTColor,
		biTextRWidth,
		biTextRColor,
		biTextBWidth,
		biTextBColor,
		biTextBTradius,
		biTextBBradius,
		biTextBgColor,
		biTextFontFamily,
		biTextFontSize,
		biTextScolor,
		biTextShadowOffsetX,
		biTextShadowOffsetY,
		biTextShadowBlur,
		hasLogo,
		titleId,
		textId,
		titleWeight,
		titleStyle,
		titleDeco,
		textWeight,
		textStyle,
		textDeco,
		textAlign,
		titleTXTSC,
		titleTXTSX,
		titleTXTSY,
		titleTXTSB,
		titleAlign,
		titleValign

	blocks.forEach((block) => {
		if (block.blockName === blockID) {
			height = block.sibHeight
			bgColor = block.sibBackgroundColor
			mTop = block.sibMarginTop
			mBottom = block.sibMarginBottom
			padding = block.sibPadding
			blWidth = block.sibBorderLeftWidth
			blColor = block.sibBorderLeftColor
			btWidth = block.sibBorderTopWidth
			btColor = block.sibBorderTopColor
			brWidth = block.sibBorderRightWidth
			brColor = block.sibBorderRightColor
			bbWidth = block.sibBorderBottomWidth
			bbColor = block.sibBorderBottomColor
			btRadius = block.sibBorderTopRadius
			bbRadius = block.sibBorderBottomRadius
			boxShadowY = block.sibShadowOffsetY
			boxShadowBlur = block.sibShadowBlur
			boxShadowColor = block.sibShadowColor
			imageWidth = block.sibImageWidth
			imageHeight = block.sibImageHeight
			imageLeft = block.sibImageLeft
			imageTop = block.sibImageTop
			bilWidth = block.sibImageBorderLeftWidth
			bilColor = block.sibImageBorderLeftColor
			bitWidth = block.sibImageBorderTopWidth
			bitColor = block.sibImageBorderTopColor
			birWidth = block.sibImageBorderRightWidth
			birColor = block.sibImageBorderRightColor
			bibWidth = block.sibImageBorderBottomWidth
			bibColor = block.sibImageBorderBottomColor
			bitRadius = block.sibImageBorderTopRadius
			bibRadius = block.sibImageBorderBottomRadius
			biSBColor = block.sibImageShadowColor
			biSBoffsetX = block.sibImageShadowOffsetX
			bisSBoffsetY = block.sibImageShadowOffsetY
			bisSBblur = block.sibImageShadowBlur
			biTitleFontColor = block.sibTitleFontColor
			biTitleBgColor = block.sibTitleBackground
			biTitleWidth = block.sibTitleWidth
			biTitleHeight = block.sibTitleHeight
			biTitleLeft = block.sibTitleLeft
			biTitleTop = block.sibTitleTop
			biTitleFontFamily = block.sibTitleFontFamily
			biTitleFontSize = fontsize_to_string(block.sibTitleFontSize)
			biTitleLWidth = block.sibTitleBorderLeftWidth
			biTitleLColor = block.sibTitleBorderLeftColor
			biTitleTWidth = block.sibTitleBorderTopWidth
			biTitleTColor = block.sibTitleBorderTopColor
			biTitleRWidth = block.sibTitleBorderRightWidth
			biTitleRColor = block.sibTitleBorderRightColor
			biTitleBWidth = block.sibTitleBorderBottomWidth
			biTitleBColor = block.sibTitleBorderBottomColor
			biTitleBTradius = block.sibTitleBorderTopRadius
			biTitleBBradius = block.sibTitleBorderBottomRadius
			biTitleScolor = block.sibTitleShadowColor
			biTitleShadowOffsetX = block.sibTitleShadowOffsetX
			biTitleShadowOffsetY = block.sibTitleShadowOffsetY
			biTitleShadowBlur = block.sibTitleShadowBlur
			biTextWidth = block.sibTextWidth
			biTextHeight = block.sibTextHeight
			biTextLeft = block.sibTextLeft
			biTextTop = block.sibTextTop
			biTextLWidth = block.sibTextBorderLeftWidth
			biTextLColor = block.sibTextBorderLeftColor
			biTextTWidth = block.sibTextBorderTopWidth
			biTextTColor = block.sibTextBorderTopColor
			biTextRWidth = block.sibTextBorderRightWidth
			biTextRColor = block.sibTextBorderRightColor
			biTextBWidth = block.sibTextBorderBottomWidth
			biTextBColor = block.sibTextBorderBottomColor
			biTextBTradius = block.sibTextBorderTopRadius
			biTextBBradius = block.sibTextBorderBottomRadius
			biTextBgColor = block.sibTextBackground
			biTextFontFamily = block.sibTextFontFamily
			biTextFontSize = fontsize_to_string(block.sibTextFontSize)
			biTextScolor = block.sibTextShadowColor
			biTextShadowOffsetX = block.sibTextShadowOffsetX
			biTextShadowOffsetY = block.sibTextShadowOffsetY
			biTextShadowBlur = block.sibTextShadowBlur
			hasLogo = block.hasLogo
			titleId = block.sibTitleId
			textId = block.sibTextId
			titleWeight = block.sibTitleFontWeight
			titleStyle = block.sibTitleFontStyle
			titleDeco = block.sibTitleFontDeco
			textWeight = block.sibTextFontWeight
			textStyle = block.sibTextFontStyle
			textDeco = block.sibTextFontDeco
			textAlign = block.sibTextAlign
			titleTXTSC = block.sibTitleTXTSC
			titleTXTSX = block.sibTitleTXTSX
			titleTXTSY = block.sibTitleTXTSY
			titleTXTSB = block.sibTitleTXTSB
			titleAlign = block.blockTitleAlignHorizontal
			titleValign = block.blockTitleAlignVertical
		}
	})
	const bgOpacity = bgColor.split(',')
	const bgOpac = bgOpacity[3].slice(0, bgOpacity[3].length - 1)
	const sOpacity = boxShadowColor.split(',')
	const sOpac = sOpacity[3].slice(0, sOpacity[3].length - 1)
	const sIOpacity = biSBColor.split(',')
	const sIOpac = sIOpacity[3].slice(0, sIOpacity[3].length - 1)
	const sTitleOpacity = biTitleFontColor.split(',')
	const sTitleOpac = sTitleOpacity[3].slice(0, sTitleOpacity[3].length - 1)
	const sTitleBgOpacity = biTitleBgColor.split(',')
	const sTitleBgOpac = sTitleBgOpacity[3].slice(0, sTitleBgOpacity[3].length - 1)
	const sTitleSOpacity = biTitleScolor.split(',')
	const sTitleSopac = sTitleSOpacity[3].slice(0, sTitleSOpacity[3].length - 1)
	const sTextBgOpacity = biTextBgColor.split(',')
	const sTextBgOpac = sTextBgOpacity[3].slice(0, sTextBgOpacity[3].length - 1)
	const sTextSOpacity = biTextScolor.split(',')
	const sTextSopac = sTextSOpacity[3].slice(0, sTextSOpacity[3].length - 1)
	const sTitleTXTSOpacity = titleTXTSC.split(',')
	const sTitleTXTSopac = sTitleTXTSOpacity[3].slice(0, sTitleTXTSOpacity[3].length - 1)
	return [
		height,
		bgColor,
		bgOpac,
		mTop,
		mBottom,
		padding,
		blWidth,
		blColor,
		btWidth,
		btColor,
		brWidth,
		brColor,
		bbWidth,
		bbColor,
		btRadius,
		bbRadius,
		boxShadowY,
		boxShadowBlur,
		boxShadowColor,
		sOpac,
		imageWidth,
		imageHeight,
		imageLeft,
		imageTop,
		bilWidth,
		bilColor,
		bitWidth,
		bitColor,
		birWidth,
		birColor,
		bibWidth,
		bibColor,
		bitRadius,
		bibRadius,
		biSBColor,
		sIOpac,
		biSBoffsetX,
		bisSBoffsetY,
		bisSBblur,
		biTitleFontColor,
		sTitleOpac,
		biTitleBgColor,
		sTitleBgOpac,
		biTitleWidth,
		biTitleHeight,
		biTitleLeft,
		biTitleTop,
		biTitleFontFamily,
		biTitleFontSize,
		biTitleLWidth,
		biTitleLColor,
		biTitleTWidth,
		biTitleTColor,
		biTitleRWidth,
		biTitleRColor,
		biTitleBWidth,
		biTitleBColor,
		biTitleBTradius,
		biTitleBBradius,
		biTitleScolor,
		sTitleSopac,
		biTitleShadowOffsetX,
		biTitleShadowOffsetY,
		biTitleShadowBlur,
		biTextWidth,
		biTextHeight,
		biTextLeft,
		biTextTop,
		biTextLWidth,
		biTextLColor,
		biTextTWidth,
		biTextTColor,
		biTextRWidth,
		biTextRColor,
		biTextBWidth,
		biTextBColor,
		biTextBTradius,
		biTextBBradius,
		biTextBgColor,
		sTextBgOpac,
		biTextFontFamily,
		biTextFontSize,
		biTextScolor,
		sTextSopac,
		biTextShadowOffsetX,
		biTextShadowOffsetY,
		biTextShadowBlur,
		hasLogo,
		titleId,
		textId,
		titleWeight,
		titleStyle,
		titleDeco,
		textWeight,
		textStyle,
		textDeco,
		textAlign,
		titleTXTSC,
		titleTXTSX,
		titleTXTSY,
		titleTXTSB,
		sTitleTXTSopac,
		titleAlign,
		titleValign,
	]
}

function get_slider_settings(blocks, blockID) {
	let sliderWidth,
		sliderHeight,
		insetWidth,
		insetHeight,
		insetLeft,
		insetTop,
		insetBgColor,
		blWidth,
		blColor,
		btWidth,
		btColor,
		brWidth,
		brColor,
		bbWidth,
		bbColor,
		btRadius,
		bbRadius,
		speed,
		pause,
		fontTitle,
		fontTitleColor,
		fontTitleSize,
		fontTitleWeight,
		fontTitleStyle,
		fontText,
		fontTextColor,
		fontTextSize,
		fontTextAlign,
		fontTextWeight,
		fontTextStyle,
		sliderBLwidth,
		sliderBLcolor,
		sliderBTwidth,
		sliderBTcolor,
		sliderBRwidth,
		sliderBRcolor,
		sliderBBwidth,
		sliderBBcolor,
		sliderBTradius,
		sliderBBradius,
		sliderShadowColor,
		sliderShadowX,
		sliderShadowY,
		sliderShadowBlur,
		sliderInsetShadowColor,
		sliderInsetShadowX,
		sliderInsetShadowY,
		sliderInsetShadowBlur,
		controlColor,
		controlHover

	blocks.forEach((block) => {
		if (block.blockName === blockID) {
			sliderWidth = block.sliderWidth
			sliderHeight = block.sliderHeight
			insetWidth = block.sliderInsetWidth
			insetHeight = block.sliderInsetHeight
			insetLeft = block.sliderInsetLeft
			insetTop = block.sliderInsetTop
			insetBgColor = block.sliderInsetBg
			blWidth = block.sliderInsetBLwidth
			blColor = block.sliderInsetBLcolor
			btWidth = block.sliderInsetBTwidth
			btColor = block.sliderInsetBTcolor
			brWidth = block.sliderInsetBRwidth
			brColor = block.sliderInsetBRcolor
			bbWidth = block.sliderInsetBBwidth
			bbColor = block.sliderInsetBBcolor
			btRadius = block.sliderInsetBTradius
			bbRadius = block.sliderInsetBBradius
			speed = calc_relation('speed', block.sliderSpeed)
			pause = calc_relation('pause', block.sliderPause)
			fontTitle = block.sliderInsetTitleFont
			fontTitleColor = block.sliderInsetTitleColor
			fontTitleSize = fontsize_to_string(block.sliderInsetTitleSize)
			fontTitleWeight = block.sliderInsetTitleWeight
			fontTitleStyle = block.sliderInsetTitleStyle
			fontText = block.sliderInsetTextFont
			fontTextColor = block.sliderInsetTextColor
			fontTextSize = fontsize_to_string(block.sliderInsetTextSize)
			fontTextAlign = block.sliderInsetTextAlign
			fontTextWeight = block.sliderInsetTextWeight
			fontTextStyle = block.sliderInsetTextStyle
			sliderBLwidth = block.sliderBLwidth
			sliderBLcolor = block.sliderBLColor
			sliderBTwidth = block.sliderBTwidth
			sliderBTcolor = block.sliderBTcolor
			sliderBRwidth = block.sliderBRwidth
			sliderBRcolor = block.sliderBRcolor
			sliderBBwidth = block.sliderBBwidth
			sliderBBcolor = block.sliderBBcolor
			sliderBTradius = block.sliderBTradius
			sliderBBradius = block.sliderBBradius
			sliderShadowColor = block.sliderShadowColor
			sliderShadowX = block.sliderShadowOffsetX
			sliderShadowY = block.sliderShadowOffsetY
			sliderShadowBlur = block.sliderShadowBlur
			sliderInsetShadowColor = block.sliderInsetShadowColor
			sliderInsetShadowX = block.sliderInsetShadowOffsetX
			sliderInsetShadowY = block.sliderInsetShadowOffsetY
			sliderInsetShadowBlur = block.sliderInsetShadowBlur
			controlColor = block.controlC
			controlHover = block.controlH
		}
	})
	const bgOpacity = insetBgColor.split(',')
	const bgOpac = bgOpacity[3].slice(0, bgOpacity[3].length - 1)
	const titleOpacity = fontTitleColor.split(',')
	const titleOpac = titleOpacity[3].slice(0, titleOpacity[3].length - 1)
	const textOpacity = fontTextColor.split(',')
	const textOpac = textOpacity[3].slice(0, textOpacity[3].length - 1)
	const sliderShadowOpacity = sliderShadowColor.split(',')
	const sliderShadowOpac = sliderShadowOpacity[3].slice(0, sliderShadowOpacity[3].length - 1)
	const sliderInsetShadowOpacity = sliderInsetShadowColor.split(',')
	const sliderInsetShadowOpac = sliderInsetShadowOpacity[3].slice(0, sliderInsetShadowOpacity[3].length - 1)

	return [
		sliderWidth,
		sliderHeight,
		insetWidth,
		insetHeight,
		insetLeft,
		insetTop,
		insetBgColor,
		bgOpac,
		blWidth,
		blColor,
		btWidth,
		btColor,
		brWidth,
		brColor,
		bbWidth,
		bbColor,
		btRadius,
		bbRadius,
		speed,
		pause,
		fontTitle,
		fontTitleColor,
		fontTitleSize,
		fontTitleWeight,
		fontTitleStyle,
		fontText,
		fontTextColor,
		fontTextSize,
		fontTextAlign,
		fontTextWeight,
		fontTextStyle,
		titleOpac,
		textOpac,
		sliderBLwidth,
		sliderBLcolor,
		sliderBTwidth,
		sliderBTcolor,
		sliderBRwidth,
		sliderBRcolor,
		sliderBBwidth,
		sliderBBcolor,
		sliderBTradius,
		sliderBBradius,
		sliderShadowColor,
		sliderShadowOpac,
		sliderShadowX,
		sliderShadowY,
		sliderShadowBlur,
		sliderInsetShadowColor,
		sliderInsetShadowOpac,
		sliderInsetShadowX,
		sliderInsetShadowY,
		sliderInsetShadowBlur,
		controlColor,
		controlHover,
	]
}

function get_column_settings(blocks, blockID, columnID) {
	let bgColor,
		mTop,
		mBottom,
		padding,
		blWidth,
		blColor,
		btWidth,
		btColor,
		brWidth,
		brColor,
		bbWidth,
		bbColor,
		btRadius,
		bbRadius,
		boxShadowX,
		boxShadowY,
		boxShadowBlur,
		boxShadowColor,
		columnHeight
	blocks.forEach((block) => {
		if (block.blockName === blockID) {
			bgColor = block.content[columnID - 1].backgroundColor
			mTop = block.content[columnID - 1].marginTop
			mBottom = block.content[columnID - 1].marginBottom
			padding = block.content[columnID - 1].padding
			blWidth = block.content[columnID - 1].borderLeftWidth
			blColor = block.content[columnID - 1].borderLeftColor
			btWidth = block.content[columnID - 1].borderTopWidth
			btColor = block.content[columnID - 1].borderTopColor
			brWidth = block.content[columnID - 1].borderRightWidth
			brColor = block.content[columnID - 1].borderRightColor
			bbWidth = block.content[columnID - 1].borderBottomWidth
			bbColor = block.content[columnID - 1].borderBottomColor
			btRadius = block.content[columnID - 1].borderTopRadius
			bbRadius = block.content[columnID - 1].borderBottomRadius
			boxShadowX = block.content[columnID - 1].columnBoxShadowX
			boxShadowY = block.content[columnID - 1].columnBoxShadowY
			boxShadowBlur = block.content[columnID - 1].columnBoxShadowBlur
			boxShadowColor = block.content[columnID - 1].columnBoxShadowColor
			columnHeight = block.content[columnID - 1].columnHeight
		}
	})
	const bgOpacity = bgColor.split(',')
	const bgOpac = bgOpacity[3].slice(0, bgOpacity[3].length - 1)
	const shadowOpacity = boxShadowColor.split(',')
	const shadowOpac = shadowOpacity[3].slice(0, shadowOpacity[3].length - 1)
	return [
		bgColor,
		bgOpac,
		mTop,
		mBottom,
		padding,
		blWidth,
		blColor,
		btWidth,
		btColor,
		brWidth,
		brColor,
		bbWidth,
		bbColor,
		btRadius,
		bbRadius,
		boxShadowX,
		boxShadowY,
		boxShadowBlur,
		boxShadowColor,
		shadowOpac,
		columnHeight,
	]
}

function get_blockTitle_settings(blocks, blockID, columnID, elementTag) {
	let fFamily,
		fSize,
		fColor,
		bgColor,
		mTop,
		mBottom,
		padding,
		titleAlignement,
		titleVerticalAlignement,
		fontWeight,
		fontStyle,
		fontDeco,
		titleWidth,
		titleHeight,
		titleSColor,
		titleSX,
		titleSY,
		titleSB
	blocks.forEach((block) => {
		if (block.blockName === blockID) {
			fFamily = block.blockTitleFontFamily
			fSize = fontsize_to_string(block.blockTitleFontSize)
			fColor = block.blockTitleFontColor
			bgColor = block.blockTitleBackgroundColor
			mTop = block.blockTitleMarginTop
			mBottom = block.blockTitleMarginBottom
			padding = block.blockTitlePadding
			titleAlignement = block.blockTitleAlignHorizontal
			titleVerticalAlignement = block.blockTitleAlignVertical
			fontWeight = block.blockTitleFontWeight
			fontStyle = block.blockTitleFontStyle
			fontDeco = block.blockTitleFontDeco
			titleWidth = block.blockTitleWidth
			titleHeight = block.blockTitleHeight
			titleSColor = block.blockTitleShadowColor
			titleSX = block.blockTitleShadowOffsetX
			titleSY = block.blockTitleShadowOffsetY
			titleSB = block.blockTitleShadowBlur
		}
	})

	//calculate the opacity from hsl
	const fOpacity = fColor.split(',')
	const fOpac = fOpacity[3].slice(0, fOpacity[3].length - 1)
	const bgOpacity = bgColor.split(',')
	const bgOpac = bgOpacity[3].slice(0, bgOpacity[3].length - 1)
	const txtSopacity = titleSColor.split(',')
	const titleSopc = txtSopacity[3].slice(0, txtSopacity[3].length - 1)
	return [
		fFamily,
		fSize,
		fColor,
		bgColor,
		fOpac,
		bgOpac,
		mTop,
		mBottom,
		padding,
		titleAlignement,
		titleVerticalAlignement,
		fontWeight,
		fontStyle,
		fontDeco,
		titleWidth,
		titleHeight,
		titleSColor,
		titleSopc,
		titleSX,
		titleSY,
		titleSB,
		null,
		null,
		null,
		null,
		null,
	]
}

function get_columnTitle_settings(blocks, blockID, columnID) {
	let fFamily,
		fSize,
		fColor,
		bgColor,
		mTop,
		mBottom,
		padding,
		titleAlignement,
		titleVerticalAlignement,
		fontWeight,
		fontStyle,
		fontDeco,
		titleWidth,
		titleHeight,
		titleSColor,
		titleSX,
		titleSY,
		titleSB,
		titleBorderRadius,
		titlePosTop,
		titlePosLeft,
		image,
		linkHover

	blocks.forEach((block) => {
		if (block.blockName === blockID) {
			fFamily = block.content[columnID - 1].titleFontFamily
			fSize = fontsize_to_string(block.content[columnID - 1].titleFontSize)
			fColor = block.content[columnID - 1].titleFontColor
			bgColor = block.content[columnID - 1].titleBackgroundColor
			mTop = block.content[columnID - 1].titleMarginTop
			mBottom = block.content[columnID - 1].titleMarginBottom
			padding = block.content[columnID - 1].titlePadding
			titleAlignement = block.content[columnID - 1].titleAlignHorizontal
			titleVerticalAlignement = block.content[columnID - 1].titleAlignVertical
			fontWeight = block.content[columnID - 1].titleFontWeight
			fontStyle = block.content[columnID - 1].titleFontStyle
			fontDeco = block.content[columnID - 1].titleFontDeco
			titleWidth = block.content[columnID - 1].titleWidth
			titleHeight = block.content[columnID - 1].titleHeight
			titleSColor = block.content[columnID - 1].titleColumnShadowColor
			titleSX = block.content[columnID - 1].titleColumnShadowOffsetX
			titleSY = block.content[columnID - 1].titleColumnShadowOffsetY
			titleSB = block.content[columnID - 1].titleColumnShadowBlur
			titleBorderRadius = block.content[columnID - 1].titleColumnBorderRadius
			titlePosTop = block.content[columnID - 1].titlePosTop
			titlePosLeft = block.content[columnID - 1].titlePosLeft
			image = block.content[columnID - 1].image
			linkHover = block.content[columnID - 1].linkHover
		}
	})

	//calculate the opacity from hsl
	const fOpacity = fColor.split(',')
	const fOpac = fOpacity[3].slice(0, fOpacity[3].length - 1)
	const bgOpacity = bgColor.split(',')
	const bgOpac = bgOpacity[3].slice(0, bgOpacity[3].length - 1)
	const ttSopacity = titleSColor.split(',')
	const titleSopc = ttSopacity[3].slice(0, ttSopacity[3].length - 1)
	return [
		fFamily,
		fSize,
		fColor,
		bgColor,
		fOpac,
		bgOpac,
		mTop,
		mBottom,
		padding,
		titleAlignement,
		titleVerticalAlignement,
		fontWeight,
		fontStyle,
		fontDeco,
		titleWidth,
		titleHeight,
		titleSColor,
		titleSopc,
		titleSX,
		titleSY,
		titleSB,
		titleBorderRadius,
		null,
		titlePosTop,
		titlePosLeft,
		image,
		linkHover,
	]
}

function get_columnText_settings(blocks, blockID, columnID) {
	let fFamily,
		fSize,
		fColor,
		bgColor,
		mTop,
		mBottom,
		padding,
		textAlignHorizontal,
		textAlignVertical,
		fontWeight,
		fontStyle,
		fontDeco,
		textWidth,
		textHeight,
		textAlign,
		textPosTop,
		textPosLeft,
		image,
		link,
		linkHoverColor
	blocks.forEach((block) => {
		if (block.blockName === blockID) {
			fFamily = block.content[columnID - 1].textFontFamily
			fSize = fontsize_to_string(block.content[columnID - 1].textFontSize)
			fColor = block.content[columnID - 1].textFontColor
			bgColor = block.content[columnID - 1].textBackgroundColor
			mTop = block.content[columnID - 1].textMarginTop
			mBottom = block.content[columnID - 1].textMarginBottom
			padding = block.content[columnID - 1].textPadding
			textAlignHorizontal = block.content[columnID - 1].textAlignHorizontal
			textAlignVertical = block.content[columnID - 1].textAlignVertical
			fontWeight = block.content[columnID - 1].textFontWeight
			fontStyle = block.content[columnID - 1].textFontStyle
			fontDeco = block.content[columnID - 1].textFontDeco
			textWidth = block.content[columnID - 1].textWidth
			textHeight = block.content[columnID - 1].textHeight
			textAlign = block.content[columnID - 1].textAlign
			textPosTop = block.content[columnID - 1].textPosTop
			textPosLeft = block.content[columnID - 1].textPosLeft
			image = block.content[columnID - 1].image
			link = block.content[columnID - 1].link
			linkHoverColor = block.content[columnID - 1].linkHover
		}
	})
	//calculate the opacity from hsl
	const fOpacity = fColor.split(',')
	const fOpac = fOpacity[3].slice(0, fOpacity[3].length - 1)
	const bgOpacity = bgColor.split(',')
	const bgOpac = bgOpacity[3].slice(0, bgOpacity[3].length - 1)
	return [
		fFamily,
		fSize,
		fColor,
		bgColor,
		fOpac,
		bgOpac,
		mTop,
		mBottom,
		padding,
		textAlignHorizontal,
		textAlignVertical,
		fontWeight,
		fontStyle,
		fontDeco,
		textWidth,
		textHeight,
		null,
		null,
		null,
		null,
		null,
		null,
		textAlign,
		textPosTop,
		textPosLeft,
		image,
		link,
		linkHoverColor,
	]
}

function get_menu_settings(blocks, blockID) {
	let blockBackgroundColor,
		blockTitleWidth,
		blockTitleHeight,
		blockTitleAlignHorizontal,
		blockTitleAlignVertical,
		blockTitleFontFamily,
		blockTitleFontColor,
		blockTitleFontSize,
		blockTitleFontWeight,
		blockTitleFontStyle,
		blockTitleFontDeco,
		blockTitleBackgroundColor,
		blockTitleMarginTop,
		blockTitleMarginBottom,
		blockTitlePadding,
		blockTitleShadowColor,
		blockTitleShadowOffsetX,
		blockTitleShadowOffsetY,
		blockTitleShadowBlur,
		blockBoxShadowX,
		blockBoxShadowY,
		blockBoxShadowBlur,
		blockBoxShadowColor,
		menuWidth,
		menuHeight,
		menuBGC,
		menuBGS,
		menuBGR,
		menuBGB,
		menuBGP,
		borderTopRadius,
		borderBottomRadius,
		borderLeftWidth,
		borderLeftStyle,
		borderLeftColor,
		borderTopWidth,
		borderTopStyle,
		borderTopColor,
		borderRightWidth,
		borderRightStyle,
		borderRightColor,
		borderBottomWidth,
		borderBottomStyle,
		borderBottomColor,
		blockMarginTop,
		blockMarginBottom,
		blockPadding,
		categoryBgColor,
		categoryPadding,
		categoryFontSize,
		categoryFontWeight,
		categoryFontStyle,
		categoryFontColor,
		categoryFontDeco,
		categoryFontFamily,
		categoryMargin,
		itemFontFamily,
		itemFontSize,
		itemFontColor,
		itemFontStyle,
		menuContainerBG,
		menuContainerMT,
		menuContainerMB,
		menuConatainerP,
		menuBG,
		menuMT,
		menuMB,
		menuP,
		menuSC,
		menuSX,
		menuSY,
		menuSB,
		menuBRT,
		menuBRB,
		menuBLW,
		menuBLS,
		menuBLC,
		menuBTW,
		menuBTS,
		menuBTC,
		menuBRW,
		menuBRS,
		menuBRC,
		menuBBW,
		menuBBS,
		menuBBC,
		itemTFC

	blocks.forEach((block) => {
		if (block.blockName === blockID) {
			blockBackgroundColor = block.blockBackgroundColor
			blockTitleWidth = block.blockTitleWidth
			blockTitleHeight = block.blockTitleHeight
			blockTitleAlignHorizontal = block.blockTitleAlignHorizontal
			blockTitleAlignVertical = block.blockTitleAlignVertical
			blockTitleFontFamily = block.blockTitleFontFamily
			blockTitleFontColor = block.blockTitleFontColor
			blockTitleFontSize = fontsize_to_string(block.blockTitleFontSize)
			blockTitleFontWeight = block.blockTitleFontWeight
			blockTitleFontStyle = block.blockTitleFontStyle
			blockTitleFontDeco = block.blockTitleFontDeco
			blockTitleBackgroundColor = block.blockTitleBackgroundColor
			blockTitleMarginTop = block.blockTitleMarginTop
			blockTitleMarginBottom = block.blockTitleMarginBottom
			blockTitlePadding = block.blockTitlePadding
			blockTitleShadowColor = block.blockTitleShadowColor
			blockTitleShadowOffsetX = block.blockTitleShadowOffsetX
			blockTitleShadowOffsetY = block.blockTitleShadowOffsetY
			blockTitleShadowBlur = block.blockTitleShadowBlur
			blockBoxShadowX = block.blockBoxShadowX
			blockBoxShadowY = block.blockBoxShadowY
			blockBoxShadowBlur = block.blockBoxShadowBlur
			blockBoxShadowColor = block.blockBoxShadowColor
			menuWidth = block.menuWidth
			menuHeight = block.menuHeight
			menuBGC = block.menuBGC
			menuBGS = block.menuBGS
			menuBGR = block.menuBGR
			menuBGB = block.menuBGB
			menuBGP = block.menuBGP
			borderTopRadius = block.borderTopRadius
			borderBottomRadius = block.borderBottomRadius
			borderLeftWidth = block.borderLeftWidth
			borderLeftStyle = block.borderLeftStyle
			borderLeftColor = block.borderLeftColor
			borderTopWidth = block.borderTopWidth
			borderTopStyle = block.borderTopStyle
			borderTopColor = block.borderTopColor
			borderRightWidth = block.borderRightWidth
			borderRightStyle = block.borderRightStyle
			borderRightColor = block.borderRightColor
			borderBottomWidth = block.borderBottomWidth
			borderBottomStyle = block.borderBottomStyle
			borderBottomColor = block.borderBottomColor
			blockMarginTop = block.blockMarginTop
			blockMarginBottom = block.blockMarginBottom
			blockPadding = block.blockPadding
			categoryBgColor = block.categoryBgColor
			categoryPadding = block.categoryPadding
			categoryFontSize = fontsize_to_string(block.categoryFontSize)
			categoryFontWeight = block.categoryFontWeight
			categoryFontStyle = block.categoryFontStyle
			categoryFontColor = block.categoryFontColor
			categoryFontDeco = block.categoryFontDeco
			categoryFontFamily = block.categoryFontFamily
			categoryMargin = block.categoryMargin
			itemFontFamily = block.itemFontFamily
			itemFontSize = fontsize_to_string(block.itemFontSize)
			itemFontColor = block.itemFontColor
			itemFontStyle = block.itemFontStyle
			menuContainerBG = block.menuContainerBG
			menuContainerMT = block.menuContainerMT
			menuContainerMB = block.menuContainerMB
			menuConatainerP = block.menuConatainerP
			menuBG = block.menuBG
			menuMT = block.menuMT
			menuMB = block.menuMB
			menuP = block.menuP
			menuSC = block.menuSC
			menuSX = block.menuSX
			menuSY = block.menuSY
			menuSB = block.menuSB
			menuBRT = block.menuBRT
			menuBRB = block.menuBRB
			menuBLW = block.menuBLW
			menuBLS = block.menuBLS
			menuBLC = block.menuBLC
			menuBTW = block.menuBTW
			menuBTS = block.menuBTS
			menuBTC = block.menuBTC
			menuBRW = block.menuBRW
			menuBRS = block.menuBRS
			menuBRC = block.menuBRC
			menuBBW = block.menuBBW
			menuBBS = block.menuBBS
			menuBBC = block.menuBBC
			itemTFC = block.itemTitleFontColor
		}
	})

	//calculate the opacity from hsl
	const ttOpacity = blockTitleBackgroundColor.split(',')
	const titleOpac = ttOpacity[3].slice(0, ttOpacity[3].length - 1)
	const bOpacity = blockBackgroundColor.split(',')
	const blockOpac = bOpacity[3].slice(0, bOpacity[3].length - 1)
	const bTshadowOpacity = blockTitleShadowColor.split(',')
	const bTShadowOpac = bTshadowOpacity[3].slice(0, bTshadowOpacity[3].length - 1)
	const mcBG = menuContainerBG.split(',')
	const mcBGOpac = mcBG[3].slice(0, mcBG[3].length - 1)
	const mOpacity = menuBG.split(',')
	const menuOpac = mOpacity[3].slice(0, mOpacity[3].length - 1)
	const mSOpacity = menuSC.split(',')
	const menuSopac = mSOpacity[3].slice(0, mSOpacity[3].length - 1)
	const mCatOpacity = categoryBgColor.split(',')
	const categoryOpac = mCatOpacity[3].slice(0, mCatOpacity[3].length - 1)
	const mCatFOpacity = categoryFontColor.split(',')
	const categoryFontOpac = mCatFOpacity[3].slice(0, mCatFOpacity[3].length - 1)
	const itemFOpacity = itemFontColor.split(',')
	const itemFontOpac = itemFOpacity[3].slice(0, itemFOpacity[3].length - 1)
	const itemTFOpacity = itemTFC.split(',')
	const itemTitleFontOpac = itemTFOpacity[3].slice(0, itemTFOpacity[3].length - 1)
	return [
		blockBackgroundColor,
		blockTitleWidth,
		blockTitleHeight,
		blockTitleAlignHorizontal,
		blockTitleAlignVertical,
		blockTitleFontFamily,
		blockTitleFontColor,
		blockTitleFontSize,
		blockTitleFontWeight,
		blockTitleFontStyle,
		blockTitleFontDeco,
		blockTitleBackgroundColor,
		blockTitleMarginTop,
		blockTitleMarginBottom,
		blockTitlePadding,
		blockTitleShadowColor,
		blockTitleShadowOffsetX,
		blockTitleShadowOffsetY,
		blockTitleShadowBlur,
		blockBoxShadowX,
		blockBoxShadowY,
		blockBoxShadowBlur,
		blockBoxShadowColor,
		menuWidth,
		menuHeight,
		menuBGC,
		menuBGS,
		menuBGR,
		menuBGB,
		menuBGP,
		borderTopRadius,
		borderBottomRadius,
		borderLeftWidth,
		borderLeftStyle,
		borderLeftColor,
		borderTopWidth,
		borderTopStyle,
		borderTopColor,
		borderRightWidth,
		borderRightStyle,
		borderRightColor,
		borderBottomWidth,
		borderBottomStyle,
		borderBottomColor,
		blockMarginTop,
		blockMarginBottom,
		blockPadding,
		categoryBgColor,
		categoryOpac,
		categoryPadding,
		categoryFontSize,
		categoryFontWeight,
		categoryFontStyle,
		categoryFontColor,
		categoryFontOpac,
		categoryFontDeco,
		categoryFontFamily,
		categoryMargin,
		itemFontFamily,
		itemFontSize,
		itemFontColor,
		itemFontOpac,
		itemFontStyle,
		titleOpac,
		blockOpac,
		bTShadowOpac,
		menuContainerBG,
		mcBGOpac,
		menuContainerMT,
		menuContainerMB,
		menuConatainerP,
		menuBG,
		menuOpac,
		menuMT,
		menuMB,
		menuP,
		menuSC,
		menuSopac,
		menuSX,
		menuSY,
		menuSB,
		menuBRT,
		menuBRB,
		menuBLW,
		menuBLS,
		menuBLC,
		menuBTW,
		menuBTS,
		menuBTC,
		menuBRW,
		menuBRS,
		menuBRC,
		menuBBW,
		menuBBS,
		menuBBC,
		itemTFC,
		itemTitleFontOpac,
	]
}

function get_rooms_settings(blocks, blockID) {
	let blockMarginTop,
		blockMarginBottom,
		blockPadding,
		blockBackgroundColor,
		blockBoxShadowX,
		blockBoxShadowY,
		blockBoxShadowBlur,
		blockBoxShadowColor,
		blockTitle,
		blockTitleWidth,
		blockTitleHeight,
		blockTitleAlignHorizontal,
		blockTitleAlignVertical,
		blockTitleFontFamily,
		blockTitleFontColor,
		blockTitleFontSize,
		blockTitleFontWeight,
		blockTitleFontStyle,
		blockTitleFontDeco,
		blockTitleBackgroundColor,
		blockTitleMarginTop,
		blockTitleMarginBottom,
		blockTitlePadding,
		blockTitleShadowColor,
		blockTitleShadowOffsetX,
		blockTitleShadowOffsetY,
		blockTitleShadowBlur,
		roomsContainerBG,
		roomsContainerMT,
		roomsContainerMB,
		roomsConatainerP,
		roomsSC,
		roomsSX,
		roomsSY,
		roomsSB,
		roomsBW,
		roomsBRT,
		roomsBRB,
		roomsBG,
		roomsMT,
		roomsMB,
		roomsBS,
		roomsBC,
		roomsTFC,
		roomsTFS,
		roomsTFSTY,
		roomsTFW,
		roomsTP,
		roomsIMGX,
		roomsIMGY,
		roomsIMGB,
		roomsIMGC,
		roomsDescShortFC,
		roomsDescShortFS,
		roomsDescShortFSTY,
		roomsDescShortFW,
		roomsDescShortP,
		roomsPriceFC,
		roomsPriceFS,
		roomsPriceFSTY,
		roomsPriceFW,
		roomsLinkFC,
		roomsLinkFS,
		roomsLinkFSTY,
		roomsLinkFW,
		roomsLinkHover,
		backgroundImage,
		backgroundSize,
		backgroundRepeat,
		borderTopRadius,
		borderBottomRadius,
		borderLeftWidth,
		borderLeftStyle,
		borderLeftColor,
		borderTopWidth,
		borderTopStyle,
		borderTopColor,
		borderRightWidth,
		borderRightStyle,
		borderRightColor,
		borderBottomWidth,
		borderBottomStyle,
		borderBottomColor,
		blockTitleTXTShadowColor,
		blockTitleTXTShadowOffsetX,
		blockTitleTXTShadowOffsetY,
		blockTitleTXTShadowBlur,
		roomsP,
		roomsTFF,
		roomsIMGW,
		roomsDescShortFF,
		roomsPriceFF,
		roomsLinkFF

	blocks.forEach((block) => {
		if (block.blockName === blockID) {
			blockMarginTop = block.blockMarginTop
			blockMarginBottom = block.blockMarginBottom
			blockPadding = block.blockPadding
			blockBackgroundColor = block.blockBackgroundColor
			blockBoxShadowX = block.blockBoxShadowX
			blockBoxShadowY = block.blockBoxShadowY
			blockBoxShadowBlur = block.blockBoxShadowBlur
			blockBoxShadowColor = block.blockBoxShadowColor
			blockTitle = block.blockTitle
			blockTitleWidth = block.blockTitleWidth
			blockTitleHeight = block.blockTitleHeight
			blockTitleAlignHorizontal = block.blockTitleAlignHorizontal
			blockTitleAlignVertical = block.blockTitleAlignVertical
			blockTitleFontFamily = block.blockTitleFontFamily
			blockTitleFontColor = block.blockTitleFontColor
			blockTitleFontSize = fontsize_to_string(block.blockTitleFontSize)
			blockTitleFontWeight = block.blockTitleFontWeight
			blockTitleFontStyle = block.blockTitleFontStyle
			blockTitleFontDeco = block.blockTitleFontDeco
			blockTitleBackgroundColor = block.blockTitleBackgroundColor
			blockTitleMarginTop = block.blockTitleMarginTop
			blockTitleMarginBottom = block.blockTitleMarginBottom
			blockTitlePadding = block.blockTitlePadding
			blockTitleShadowColor = block.blockTitleShadowColor
			blockTitleShadowOffsetX = block.blockTitleShadowOffsetX
			blockTitleShadowOffsetY = block.blockTitleShadowOffsetY
			blockTitleShadowBlur = block.blockTitleShadowBlur
			roomsContainerBG = block.roomsContainerBG
			roomsContainerMT = block.roomsContainerMT
			roomsContainerMB = block.roomsContainerMB
			roomsConatainerP = block.roomsConatainerP
			roomsSC = block.roomsSC
			roomsSX = block.roomsSX
			roomsSY = block.roomsSY
			roomsSB = block.roomsSB
			roomsBW = block.roomsBW
			roomsBRT = block.roomsBRT
			roomsBRB = block.roomsBRB
			roomsBG = block.roomsBG
			roomsMT = block.roomsMT
			roomsMB = block.roomsMB
			roomsBS = block.roomsBS
			roomsBC = block.roomsBC
			roomsTFC = block.roomsTFC
			roomsTFS = fontsize_to_string(block.roomsTFS)
			roomsTFSTY = block.roomsTFSTY
			roomsTFW = block.roomsTFW
			roomsTP = block.roomsTP
			roomsIMGX = block.roomsIMGX
			roomsIMGY = block.roomsIMGY
			roomsIMGB = block.roomsIMGB
			roomsIMGC = block.roomsIMGC
			roomsDescShortFF = block.roomsDescShortFF
			roomsDescShortFC = block.roomsDescShortFC
			roomsDescShortFS = fontsize_to_string(block.roomsDescShortFS)
			roomsDescShortFSTY = block.roomsDescShortFSTY
			roomsDescShortFW = block.roomsDescShortFW
			roomsDescShortP = block.roomsDescShortP
			roomsPriceFC = block.roomsPriceFC
			roomsPriceFS = fontsize_to_string(block.roomsPriceFS)
			roomsPriceFSTY = block.roomsPriceFSTY
			roomsPriceFW = block.roomsPriceFW
			roomsLinkFC = block.roomsLinkFC
			roomsLinkFS = fontsize_to_string(block.roomsLinkFS)
			roomsLinkFSTY = block.roomsLinkFSTY
			roomsLinkFW = block.roomsLinkFW
			roomsLinkHover = block.roomsLinkHover
			backgroundImage = block.backgroundImage
			backgroundSize = block.backgroundSize
			backgroundRepeat = block.backgroundRepeat
			borderTopRadius = block.borderTopRadius
			borderBottomRadius = block.borderBottomRadius
			borderLeftWidth = block.borderLeftWidth
			borderLeftStyle = block.borderLeftStyle
			borderLeftColor = block.borderLeftColor
			borderTopWidth = block.borderTopWidth
			borderTopStyle = block.borderTopStyle
			borderTopColor = block.borderTopColor
			borderRightWidth = block.borderRightWidth
			borderRightStyle = block.borderRightStyle
			borderRightColor = block.borderRightColor
			borderBottomWidth = block.borderBottomWidth
			borderBottomStyle = block.borderBottomStyle
			borderBottomColor = block.borderBottomColor
			blockTitleTXTShadowColor = block.blockTitleTXTShadowColor
			blockTitleTXTShadowOffsetX = block.blockTitleTXTShadowOffsetX
			blockTitleTXTShadowOffsetY = block.blockTitleTXTShadowOffsetY
			blockTitleTXTShadowBlur = block.blockTitleTXTShadowBlur
			roomsP = block.roomsP
			roomsTFF = block.roomsTFF
			roomsIMGW = block.roomsIMGW
			roomsPriceFF = block.roomsPriceFF
			roomsLinkFF = block.roomsLinkFF
		}
	})

	//calculate the opacity from hsl
	const bbGOpacity = blockBackgroundColor.split(',')
	const bbGOpac = bbGOpacity[3].slice(0, bbGOpacity[3].length - 1)
	const btOpacity = blockTitleBackgroundColor.split(',')
	const btOpac = btOpacity[3].slice(0, btOpacity[3].length - 1)
	const bCOpacity = borderLeftColor.split(',')
	const bCOpac = bCOpacity[3].slice(0, bCOpacity[3].length - 1)

	return [
		blockMarginTop,
		blockMarginBottom,
		blockPadding,
		blockBackgroundColor,
		blockBoxShadowX,
		blockBoxShadowY,
		blockBoxShadowBlur,
		blockBoxShadowColor,
		blockTitle,
		blockTitleWidth,
		blockTitleHeight,
		blockTitleAlignHorizontal,
		blockTitleAlignVertical,
		blockTitleFontFamily,
		blockTitleFontColor,
		blockTitleFontSize,
		blockTitleFontWeight,
		blockTitleFontStyle,
		blockTitleFontDeco,
		blockTitleBackgroundColor,
		blockTitleMarginTop,
		blockTitleMarginBottom,
		blockTitlePadding,
		blockTitleShadowColor,
		blockTitleShadowOffsetX,
		blockTitleShadowOffsetY,
		blockTitleShadowBlur,
		roomsContainerBG,
		roomsContainerMT,
		roomsContainerMB,
		roomsConatainerP,
		roomsSC,
		roomsSX,
		roomsSY,
		roomsSB,
		roomsBW,
		roomsBRT,
		roomsBG,
		roomsMT,
		roomsMB,
		roomsBS,
		roomsBC,
		roomsTFC,
		roomsTFS,
		roomsTFSTY,
		roomsTFW,
		roomsTP,
		roomsIMGX,
		roomsIMGY,
		roomsIMGB,
		roomsIMGC,
		roomsDescShortFC,
		roomsDescShortFS,
		roomsDescShortFSTY,
		roomsDescShortFW,
		roomsDescShortP,
		roomsPriceFC,
		roomsPriceFS,
		roomsPriceFSTY,
		roomsPriceFW,
		roomsLinkFC,
		roomsLinkFS,
		roomsLinkFSTY,
		roomsLinkFW,
		roomsLinkHover,
		bbGOpac,
		btOpac,
		backgroundImage,
		backgroundSize,
		backgroundRepeat,
		borderTopRadius,
		borderBottomRadius,
		borderLeftWidth,
		borderLeftStyle,
		borderLeftColor,
		borderTopWidth,
		borderTopStyle,
		borderTopColor,
		borderRightWidth,
		borderRightStyle,
		borderRightColor,
		borderBottomWidth,
		borderBottomStyle,
		borderBottomColor,
		bCOpac,
		blockTitleTXTShadowColor,
		blockTitleTXTShadowOffsetX,
		blockTitleTXTShadowOffsetY,
		blockTitleTXTShadowBlur,
		roomsP,
		roomsBRB,
		roomsTFF,
		roomsIMGW,
		roomsDescShortFF,
		roomsPriceFF,
		roomsLinkFF,
	]
}

function get_columnImage_settings(blocks, blockID, columnID) {
	let image,
		imgWidth,
		shadowX,
		shadowY,
		shadowBlur,
		shadowColor,
		blWidth,
		blColor,
		btWidth,
		btColor,
		brWidth,
		brColor,
		bbWidth,
		bbColor,
		marginTop,
		marginBottom,
		padding,
		borderBTradius,
		borderBBradius,
		columnBackground
	blocks.forEach((block) => {
		if (block.blockName === blockID) {
			image = block.content[columnID - 1].image
			imgWidth = block.content[columnID - 1].imageWidth
			shadowX = block.content[columnID - 1].boxShadowX
			shadowY = block.content[columnID - 1].boxShadowY
			shadowBlur = block.content[columnID - 1].boxShadowBlur
			shadowColor = block.content[columnID - 1].boxShadowColor
			blWidth = block.content[columnID - 1].imageBorderLeftWidth
			blColor = block.content[columnID - 1].imageBorderLeftColor
			btWidth = block.content[columnID - 1].imageBorderTopWidth
			btColor = block.content[columnID - 1].imageBorderTopColor
			brWidth = block.content[columnID - 1].imageBorderRightWidth
			brColor = block.content[columnID - 1].imageBorderRightColor
			bbWidth = block.content[columnID - 1].imageBorderBottomWidth
			bbColor = block.content[columnID - 1].imageBorderBottomColor
			marginTop = block.content[columnID - 1].imageMarginTop
			marginBottom = block.content[columnID - 1].imageMarginBottom
			padding = block.content[columnID - 1].imagePadding
			borderBTradius = block.content[columnID - 1].imageBorderTopRadius
			borderBBradius = block.content[columnID - 1].imageBorderBottomRadius
			//the background-color of the column
			columnBackground = block.content[columnID - 1].backgroundColor
		}
	})
	//calculate the opacity from hsl
	const sOpacity = shadowColor.split(',')
	const sOpac = sOpacity[3].slice(0, sOpacity[3].length - 1)

	return [
		image,
		imgWidth,
		shadowX,
		shadowY,
		shadowBlur,
		shadowColor,
		sOpac,
		blWidth,
		blColor,
		btWidth,
		btColor,
		brWidth,
		brColor,
		bbWidth,
		bbColor,
		marginTop,
		marginBottom,
		padding,
		borderBTradius,
		borderBBradius,
		columnBackground,
	]
}

function get_booking_settings(blocks, blockID) {
	let blockTitleWidth,
		blockTitleHeight,
		blockTitleAlignHorizontal,
		blockTitleAlignVertical,
		blockTitleFontFamily,
		blockTitleFontColor,
		blockTitleFontSize,
		blockTitleFontWeight,
		blockTitleFontStyle,
		blockTitleFontDeco,
		blockTitleBackgroundColor,
		blockTitleMarginTop,
		blockTitleMarginBottom,
		blockTitlePadding,
		blockTitleShadowColor,
		blockTitleShadowOffsetX,
		blockTitleShadowOffsetY,
		blockTitleShadowBlur,
		inputFontColor,
		inputFontFamily,
		inputFontSize,
		inputBorderWidth,
		inputBorderColor,
		inputBg,
		inputFocus,
		inputShadowX,
		inputShadowY,
		inputShadowBlur,
		inputShadowColor,
		labelFontSize,
		lableFontColor,
		lableFontFF,
		labelMarginTop,
		labelMarginBottom,
		confFF,
		confColor,
		backgroundColor,
		backgroundImage,
		backgroundSize,
		backgroundRepeat,
		borderTopRadius,
		borderBottomRadius,
		borderLeftWidth,
		borderLeftStyle,
		borderLeftColor,
		borderTopWidth,
		borderTopStyle,
		borderTopColor,
		borderRightWidth,
		borderRightStyle,
		borderRightColor,
		borderBottomWidth,
		borderBottomStyle,
		borderBottomColor,
		marginTop,
		marginBottom,
		padding,
		blockBoxShadowX,
		blockBoxShadowY,
		blockBoxShadowBlur,
		blockBoxShadowColor,
		buttonBg,
		buttonBgHover,
		buttonFontColor,
		buttonFontHover,
		buttonFontFamily,
		buttonFontSize,
		buttonBorderWidth,
		buttonBorderColor,
		buttonBorderRadius,
		pickerColorSelected,
		pickerColorDisabled,
		pickerColor,
		pickerColorBorder,
		pickerColorHover,
		respColor,
		titleBarSC,
		titleBarY,
		titleBarB,
		selectionBG,
		labelWeight,
		labelStyle,
		labelDeco,
		selectionBLC,
		selectionBLW,
		selectionBTC,
		selectionBTW,
		selectionBRC,
		selectionBRW,
		selectionBBC,
		selectionBBW,
		selectionSC,
		selectionSX,
		selectionSY,
		selectionSB

	blocks.forEach((block) => {
		if (block.blockName === blockID) {
			blockTitleWidth = block.blockTitleWidth
			blockTitleHeight = block.blockTitleHeight
			blockTitleAlignHorizontal = block.blockTitleAlignHorizontal
			blockTitleAlignVertical = block.blockTitleAlignVertical
			blockTitleFontFamily = block.blockTitleFontFamily
			blockTitleFontColor = block.blockTitleFontColor
			blockTitleFontSize = block.blockTitleFontSize
			blockTitleFontWeight = block.blockTitleFontWeight
			blockTitleFontStyle = block.blockTitleFontStyle
			blockTitleFontDeco = block.blockTitleFontDeco
			blockTitleBackgroundColor = block.blockTitleBackgroundColor
			blockTitleMarginTop = block.blockTitleMarginTop
			blockTitleMarginBottom = block.blockTitleMarginBottom
			blockTitlePadding = block.blockTitlePadding
			blockTitleShadowColor = block.blockTitleShadowColor
			blockTitleShadowOffsetX = block.blockTitleShadowOffsetX
			blockTitleShadowOffsetY = block.blockTitleShadowOffsetY
			blockTitleShadowBlur = block.blockTitleShadowBlur
			inputFontColor = block.inputFontColor
			inputFontFamily = block.inputFontFamily
			inputFontSize = block.inputFontSize
			inputBorderWidth = block.inputBorderWidth
			inputBorderColor = block.inputBorderColor
			inputBg = block.inputBg
			inputFocus = block.inputFocus
			inputShadowX = block.inputShadowX
			inputShadowY = block.inputShadowY
			inputShadowBlur = block.inputShadowBlur
			inputShadowColor = block.inputShadowColor
			labelFontSize = block.labelFontSize
			lableFontColor = block.lableFontColor
			lableFontFF = block.lableFontFF
			labelMarginTop = block.labelMarginTop
			labelMarginBottom = block.labelMarginBottom
			confFF = block.confFF
			confColor = block.confColor
			backgroundColor = block.backgroundColor
			backgroundImage = block.backgroundImage
			backgroundSize = block.backgroundSize
			backgroundRepeat = block.backgroundRepeat
			borderTopRadius = block.borderTopRadius
			borderBottomRadius = block.borderBottomRadius
			borderLeftWidth = block.borderLeftWidth
			borderLeftStyle = block.borderLeftStyle
			borderLeftColor = block.borderLeftColor
			borderTopWidth = block.borderTopWidth
			borderTopStyle = block.borderTopStyle
			borderTopColor = block.borderTopColor
			borderRightWidth = block.borderRightWidth
			borderRightStyle = block.borderRightStyle
			borderRightColor = block.borderRightColor
			borderBottomWidth = block.borderBottomWidth
			borderBottomStyle = block.borderBottomStyle
			borderBottomColor = block.borderBottomColor
			marginTop = block.marginTop
			marginBottom = block.marginBottom
			padding = block.padding
			blockBoxShadowX = block.blockBoxShadowX
			blockBoxShadowY = block.blockBoxShadowY
			blockBoxShadowBlur = block.blockBoxShadowBlur
			blockBoxShadowColor = block.blockBoxShadowColor
			buttonBg = block.buttonBg
			buttonBgHover = block.buttonBgHover
			buttonFontColor = block.buttonFontColor
			buttonFontHover = block.buttonFontHover
			buttonFontFamily = block.buttonFontFamily
			buttonFontSize = block.buttonFontSize
			buttonBorderWidth = block.buttonBorderWidth
			buttonBorderColor = block.buttonBorderColor
			buttonBorderRadius = block.buttonBorderRadius
			pickerColorSelected = block.pickerColorSelected
			pickerColorDisabled = block.pickerColorDisabled
			pickerColor = block.pickerColor
			pickerColorBorder = block.pickerColorBorder
			pickerColorHover = block.pickerColorHover
			respColor = block.respColor
			titleBarSC = block.blockTitlebarSC
			titleBarY = block.blockTitlebarY
			titleBarB = block.blockTitlebarB
			selectionBG = block.selectionBG
			labelWeight = block.labelWeight
			labelStyle = block.labelStyle
			labelDeco = block.labelDeco
			selectionBLC = block.selectionBLC
			selectionBLW = block.selectionBLW
			selectionBTC = block.selectionBTC
			selectionBTW = block.selectionBTW
			selectionBRC = block.selectionBRC
			selectionBRW = block.selectionBRW
			selectionBBC = block.selectionBBC
			selectionBBW = block.selectionBBW
			selectionSC = block.selectionSC
			selectionSX = block.selectionSX
			selectionSY = block.selectionSY
			selectionSB = block.selectionSB
		}
	})

	//calculate the opacity from hsl
	const bgOpacity = backgroundColor.split(',')
	const bgOpac = bgOpacity[3].slice(0, bgOpacity[3].length - 1)

	const bgTitleOpacity = blockTitleBackgroundColor.split(',')
	const bgTitleOpac = bgTitleOpacity[3].slice(0, bgTitleOpacity[3].length - 1)

	const bgSelectionOpacity = selectionBG.split(',')
	const bgSelectionOpac = bgSelectionOpacity[3].slice(0, bgSelectionOpacity[3].length - 1)

	return [
		blockTitleWidth,
		blockTitleHeight,
		blockTitleAlignHorizontal,
		blockTitleAlignVertical,
		blockTitleFontFamily,
		blockTitleFontColor,
		blockTitleFontSize,
		blockTitleFontWeight,
		blockTitleFontStyle,
		blockTitleFontDeco,
		blockTitleBackgroundColor,
		blockTitleMarginTop,
		blockTitleMarginBottom,
		blockTitlePadding,
		blockTitleShadowColor,
		blockTitleShadowOffsetX,
		blockTitleShadowOffsetY,
		blockTitleShadowBlur,
		inputFontColor,
		inputFontFamily,
		inputFontSize,
		inputBorderWidth,
		inputBorderColor,
		inputBg,
		inputFocus,
		inputShadowX,
		inputShadowY,
		inputShadowBlur,
		inputShadowColor,
		labelFontSize,
		lableFontColor,
		lableFontFF,
		labelMarginTop,
		labelMarginBottom,
		confFF,
		confColor,
		backgroundColor,
		backgroundImage,
		backgroundSize,
		backgroundRepeat,
		borderTopRadius,
		borderBottomRadius,
		borderLeftWidth,
		borderLeftStyle,
		borderLeftColor,
		borderTopWidth,
		borderTopStyle,
		borderTopColor,
		borderRightWidth,
		borderRightStyle,
		borderRightColor,
		borderBottomWidth,
		borderBottomStyle,
		borderBottomColor,
		marginTop,
		marginBottom,
		padding,
		blockBoxShadowX,
		blockBoxShadowY,
		blockBoxShadowBlur,
		blockBoxShadowColor,
		buttonBg,
		buttonBgHover,
		buttonFontColor,
		buttonFontHover,
		buttonFontFamily,
		buttonFontSize,
		buttonBorderWidth,
		buttonBorderColor,
		buttonBorderRadius,
		pickerColorSelected,
		pickerColorDisabled,
		pickerColor,
		pickerColorBorder,
		pickerColorHover,
		respColor,
		bgOpac,
		bgTitleOpac,
		titleBarSC,
		titleBarY,
		titleBarB,
		selectionBG,
		bgSelectionOpac,
		labelWeight,
		labelStyle,
		labelDeco,
		selectionBLC,
		selectionBLW,
		selectionBTC,
		selectionBTW,
		selectionBRC,
		selectionBRW,
		selectionBBC,
		selectionBBW,
		selectionSC,
		selectionSX,
		selectionSY,
		selectionSB,
	]
}

function calc_relation(cmd, value) {
	let returnValue
	if (cmd === 'pause') {
		switch (value) {
			case 2:
				returnValue = 0
				break

			case 3:
				returnValue = 1
				break

			case 4:
				returnValue = 2
				break

			case 5:
				returnValue = 3
				break

			case 6:
				returnValue = 4
				break

			case 7:
				returnValue = 5
				break
		}
	}

	if (cmd === 'speed') {
		switch (value) {
			case 2000:
				returnValue = 5
				break

			case 3000:
				returnValue = 4
				break

			case 4000:
				returnValue = 3
				break

			case 5000:
				returnValue = 2
				break

			case 6000:
				returnValue = 1
				break

			case 7000:
				returnValue = 0
				break
		}
	}

	return returnValue
}
